/**
 * Pre-built GraphQL operation strings for all CDK-managed models.
 * Generated from amplify/cdk-models/model-configs.ts
 */

// ============================================
// UserPresence
// ============================================

const userPresenceFields = `userId isOnline lastSeenAt status createdAt updatedAt`;

export const getUserPresence = /* GraphQL */ `
  query GetUserPresence($userId: String!) {
    getUserPresence(userId: $userId) {
      ${userPresenceFields}
    }
  }
`;

export const listUserPresences = /* GraphQL */ `
  query ListUserPresences($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserPresences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userPresenceFields} }
      nextToken
    }
  }
`;

export const createUserPresence = /* GraphQL */ `
  mutation CreateUserPresence($input: CreateUserPresenceInput!) {
    createUserPresence(input: $input) {
      ${userPresenceFields}
    }
  }
`;

export const updateUserPresence = /* GraphQL */ `
  mutation UpdateUserPresence($input: UpdateUserPresenceInput!) {
    updateUserPresence(input: $input) {
      ${userPresenceFields}
    }
  }
`;

export const deleteUserPresence = /* GraphQL */ `
  mutation DeleteUserPresence($userId: String!) {
    deleteUserPresence(userId: $userId) {
      ${userPresenceFields}
    }
  }
`;

// ============================================
// ApplicationSettings
// ============================================

const applicationSettingsFields = `key value description createdAt updatedAt`;

export const getApplicationSettings = /* GraphQL */ `
  query GetApplicationSettings($key: String!) {
    getApplicationSettings(key: $key) {
      ${applicationSettingsFields}
    }
  }
`;

export const listApplicationSettings = /* GraphQL */ `
  query ListApplicationSettings($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listApplicationSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${applicationSettingsFields} }
      nextToken
    }
  }
`;

export const createApplicationSettings = /* GraphQL */ `
  mutation CreateApplicationSettings($input: CreateApplicationSettingsInput!) {
    createApplicationSettings(input: $input) {
      ${applicationSettingsFields}
    }
  }
`;

export const updateApplicationSettings = /* GraphQL */ `
  mutation UpdateApplicationSettings($input: UpdateApplicationSettingsInput!) {
    updateApplicationSettings(input: $input) {
      ${applicationSettingsFields}
    }
  }
`;

export const deleteApplicationSettings = /* GraphQL */ `
  mutation DeleteApplicationSettings($key: String!) {
    deleteApplicationSettings(key: $key) {
      ${applicationSettingsFields}
    }
  }
`;

// ============================================
// UserSettings
// ============================================

const userSettingsFields = `id owner language notifyMessages notifyPrompts notifyResponses notifyLikes notifyModerationFlags createdAt updatedAt`;

export const getUserSettings = /* GraphQL */ `
  query GetUserSettings($id: ID!) {
    getUserSettings(id: $id) {
      ${userSettingsFields}
    }
  }
`;

export const listUserSettings = /* GraphQL */ `
  query ListUserSettings($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userSettingsFields} }
      nextToken
    }
  }
`;

export const createUserSettings = /* GraphQL */ `
  mutation CreateUserSettings($input: CreateUserSettingsInput!) {
    createUserSettings(input: $input) {
      ${userSettingsFields}
    }
  }
`;

export const updateUserSettings = /* GraphQL */ `
  mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      ${userSettingsFields}
    }
  }
`;

export const deleteUserSettings = /* GraphQL */ `
  mutation DeleteUserSettings($id: ID!) {
    deleteUserSettings(id: $id) {
      ${userSettingsFields}
    }
  }
`;

// ============================================
// UserPoints
// ============================================

const userPointsFields = `id totalPoints createdAt updatedAt`;

export const getUserPoints = /* GraphQL */ `
  query GetUserPoints($id: ID!) {
    getUserPoints(id: $id) {
      ${userPointsFields}
    }
  }
`;

export const listUserPoints = /* GraphQL */ `
  query ListUserPoints($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserPoints(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userPointsFields} }
      nextToken
    }
  }
`;

export const createUserPoints = /* GraphQL */ `
  mutation CreateUserPoints($input: CreateUserPointsInput!) {
    createUserPoints(input: $input) {
      ${userPointsFields}
    }
  }
`;

export const updateUserPoints = /* GraphQL */ `
  mutation UpdateUserPoints($input: UpdateUserPointsInput!) {
    updateUserPoints(input: $input) {
      ${userPointsFields}
    }
  }
`;

export const deleteUserPoints = /* GraphQL */ `
  mutation DeleteUserPoints($id: ID!) {
    deleteUserPoints(id: $id) {
      ${userPointsFields}
    }
  }
`;

// ============================================
// PollVote
// ============================================

const pollVoteFields = `pollId voterId optionIndices createdAt updatedAt`;

export const getPollVote = /* GraphQL */ `
  query GetPollVote($pollId: String!, $voterId: String!) {
    getPollVote(pollId: $pollId, voterId: $voterId) {
      ${pollVoteFields}
    }
  }
`;

export const listPollVotes = /* GraphQL */ `
  query ListPollVotes($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPollVotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${pollVoteFields} }
      nextToken
    }
  }
`;

export const votesByPoll = /* GraphQL */ `
  query VotesByPoll($pollId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    votesByPoll(pollId: $pollId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${pollVoteFields} }
      nextToken
    }
  }
`;

export const createPollVote = /* GraphQL */ `
  mutation CreatePollVote($input: CreatePollVoteInput!) {
    createPollVote(input: $input) {
      ${pollVoteFields}
    }
  }
`;

export const updatePollVote = /* GraphQL */ `
  mutation UpdatePollVote($input: UpdatePollVoteInput!) {
    updatePollVote(input: $input) {
      ${pollVoteFields}
    }
  }
`;

export const deletePollVote = /* GraphQL */ `
  mutation DeletePollVote($pollId: String!, $voterId: String!) {
    deletePollVote(pollId: $pollId, voterId: $voterId) {
      ${pollVoteFields}
    }
  }
`;

// ============================================
// PointsLedger
// ============================================

const pointsLedgerFields = `id userId eventType sourceId pointsDelta createdAt updatedAt`;

export const getPointsLedger = /* GraphQL */ `
  query GetPointsLedger($id: ID!) {
    getPointsLedger(id: $id) {
      ${pointsLedgerFields}
    }
  }
`;

export const listPointsLedgers = /* GraphQL */ `
  query ListPointsLedgers($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPointsLedgers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${pointsLedgerFields} }
      nextToken
    }
  }
`;

export const ledgerByUserId = /* GraphQL */ `
  query LedgerByUserId($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    ledgerByUserId(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${pointsLedgerFields} }
      nextToken
    }
  }
`;

export const createPointsLedger = /* GraphQL */ `
  mutation CreatePointsLedger($input: CreatePointsLedgerInput!) {
    createPointsLedger(input: $input) {
      ${pointsLedgerFields}
    }
  }
`;

export const updatePointsLedger = /* GraphQL */ `
  mutation UpdatePointsLedger($input: UpdatePointsLedgerInput!) {
    updatePointsLedger(input: $input) {
      ${pointsLedgerFields}
    }
  }
`;

export const deletePointsLedger = /* GraphQL */ `
  mutation DeletePointsLedger($id: ID!) {
    deletePointsLedger(id: $id) {
      ${pointsLedgerFields}
    }
  }
`;

// ============================================
// LeaderboardSettings
// ============================================

const leaderboardSettingsFields = `id owner preferredAudience preferredTimeWindow hideFromPublicLeaderboard lastViewedAt createdAt updatedAt`;

export const getLeaderboardSettings = /* GraphQL */ `
  query GetLeaderboardSettings($id: ID!) {
    getLeaderboardSettings(id: $id) {
      ${leaderboardSettingsFields}
    }
  }
`;

export const listLeaderboardSettings = /* GraphQL */ `
  query ListLeaderboardSettings($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listLeaderboardSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${leaderboardSettingsFields} }
      nextToken
    }
  }
`;

export const createLeaderboardSettings = /* GraphQL */ `
  mutation CreateLeaderboardSettings($input: CreateLeaderboardSettingsInput!) {
    createLeaderboardSettings(input: $input) {
      ${leaderboardSettingsFields}
    }
  }
`;

export const updateLeaderboardSettings = /* GraphQL */ `
  mutation UpdateLeaderboardSettings($input: UpdateLeaderboardSettingsInput!) {
    updateLeaderboardSettings(input: $input) {
      ${leaderboardSettingsFields}
    }
  }
`;

export const deleteLeaderboardSettings = /* GraphQL */ `
  mutation DeleteLeaderboardSettings($id: ID!) {
    deleteLeaderboardSettings(id: $id) {
      ${leaderboardSettingsFields}
    }
  }
`;

// ============================================
// NotificationToken
// ============================================

const notificationTokenFields = `userId deviceId owner platform token isActive createdAt updatedAt`;

export const getNotificationToken = /* GraphQL */ `
  query GetNotificationToken($userId: String!, $deviceId: String!) {
    getNotificationToken(userId: $userId, deviceId: $deviceId) {
      ${notificationTokenFields}
    }
  }
`;

export const listNotificationTokens = /* GraphQL */ `
  query ListNotificationTokens($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listNotificationTokens(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${notificationTokenFields} }
      nextToken
    }
  }
`;

export const tokensByUserId = /* GraphQL */ `
  query TokensByUserId($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    tokensByUserId(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${notificationTokenFields} }
      nextToken
    }
  }
`;

export const createNotificationToken = /* GraphQL */ `
  mutation CreateNotificationToken($input: CreateNotificationTokenInput!) {
    createNotificationToken(input: $input) {
      ${notificationTokenFields}
    }
  }
`;

export const updateNotificationToken = /* GraphQL */ `
  mutation UpdateNotificationToken($input: UpdateNotificationTokenInput!) {
    updateNotificationToken(input: $input) {
      ${notificationTokenFields}
    }
  }
`;

export const deleteNotificationToken = /* GraphQL */ `
  mutation DeleteNotificationToken($userId: String!, $deviceId: String!) {
    deleteNotificationToken(userId: $userId, deviceId: $deviceId) {
      ${notificationTokenFields}
    }
  }
`;

// ============================================
// UserDeviceKey
// ============================================

const userDeviceKeyFields = `userId deviceId owner publicIdentityKey publicPreKey publicPreKeySignature deviceName lastSeenAt createdAt updatedAt`;

export const getUserDeviceKey = /* GraphQL */ `
  query GetUserDeviceKey($userId: String!, $deviceId: String!) {
    getUserDeviceKey(userId: $userId, deviceId: $deviceId) {
      ${userDeviceKeyFields}
    }
  }
`;

export const listUserDeviceKeys = /* GraphQL */ `
  query ListUserDeviceKeys($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserDeviceKeys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userDeviceKeyFields} }
      nextToken
    }
  }
`;

export const createUserDeviceKey = /* GraphQL */ `
  mutation CreateUserDeviceKey($input: CreateUserDeviceKeyInput!) {
    createUserDeviceKey(input: $input) {
      ${userDeviceKeyFields}
    }
  }
`;

export const updateUserDeviceKey = /* GraphQL */ `
  mutation UpdateUserDeviceKey($input: UpdateUserDeviceKeyInput!) {
    updateUserDeviceKey(input: $input) {
      ${userDeviceKeyFields}
    }
  }
`;

export const deleteUserDeviceKey = /* GraphQL */ `
  mutation DeleteUserDeviceKey($userId: String!, $deviceId: String!) {
    deleteUserDeviceKey(userId: $userId, deviceId: $deviceId) {
      ${userDeviceKeyFields}
    }
  }
`;

export const deviceKeysByUser = /* GraphQL */ `
  query DeviceKeysByUser($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    deviceKeysByUser(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${userDeviceKeyFields} }
      nextToken
    }
  }
`;

// ============================================
// PromptStats
// ============================================

const promptStatsFields = `id promptId creatorUserId deliveredCount responseCount likeCount likesAwarded tierAwarded spamPenaltyApplied computedAt createdAt updatedAt`;

export const getPromptStats = /* GraphQL */ `
  query GetPromptStats($id: ID!) {
    getPromptStats(id: $id) {
      ${promptStatsFields}
    }
  }
`;

export const listPromptStats = /* GraphQL */ `
  query ListPromptStats($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPromptStats(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${promptStatsFields} }
      nextToken
    }
  }
`;

export const statsByPromptId = /* GraphQL */ `
  query StatsByPromptId($promptId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    statsByPromptId(promptId: $promptId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptStatsFields} }
      nextToken
    }
  }
`;

export const createPromptStats = /* GraphQL */ `
  mutation CreatePromptStats($input: CreatePromptStatsInput!) {
    createPromptStats(input: $input) {
      ${promptStatsFields}
    }
  }
`;

export const updatePromptStats = /* GraphQL */ `
  mutation UpdatePromptStats($input: UpdatePromptStatsInput!) {
    updatePromptStats(input: $input) {
      ${promptStatsFields}
    }
  }
`;

export const deletePromptStats = /* GraphQL */ `
  mutation DeletePromptStats($id: ID!) {
    deletePromptStats(id: $id) {
      ${promptStatsFields}
    }
  }
`;

// ============================================
// LeaderboardEntry
// ============================================

const leaderboardEntryFields = `id timeWindow userId points rank previousRank userHandle userDisplayName userAvatarUrl isBlueCheck computedAt windowRankKey isEligible createdAt updatedAt`;

export const getLeaderboardEntry = /* GraphQL */ `
  query GetLeaderboardEntry($id: ID!) {
    getLeaderboardEntry(id: $id) {
      ${leaderboardEntryFields}
    }
  }
`;

export const listLeaderboardEntries = /* GraphQL */ `
  query ListLeaderboardEntries($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listLeaderboardEntries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${leaderboardEntryFields} }
      nextToken
    }
  }
`;

export const createLeaderboardEntry = /* GraphQL */ `
  mutation CreateLeaderboardEntry($input: CreateLeaderboardEntryInput!) {
    createLeaderboardEntry(input: $input) {
      ${leaderboardEntryFields}
    }
  }
`;

export const updateLeaderboardEntry = /* GraphQL */ `
  mutation UpdateLeaderboardEntry($input: UpdateLeaderboardEntryInput!) {
    updateLeaderboardEntry(input: $input) {
      ${leaderboardEntryFields}
    }
  }
`;

export const deleteLeaderboardEntry = /* GraphQL */ `
  mutation DeleteLeaderboardEntry($id: ID!, $rank: Int!) {
    deleteLeaderboardEntry(id: $id, rank: $rank) {
      ${leaderboardEntryFields}
    }
  }
`;

// GSI: leaderboardByWindow
export const leaderboardByWindow = /* GraphQL */ `
  query LeaderboardByWindow($timeWindow: String!, $rank: Int, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    leaderboardByWindow(timeWindow: $timeWindow, rank: $rank, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${leaderboardEntryFields} }
      nextToken
    }
  }
`;

// ============================================
// UserPointsAggregate
// ============================================

const userPointsAggregateFields = `userId owner points24h points7d pointsAllTime lastUpdatedAt isEligible createdAt updatedAt`;

export const getUserPointsAggregate = /* GraphQL */ `
  query GetUserPointsAggregate($userId: String!) {
    getUserPointsAggregate(userId: $userId) {
      ${userPointsAggregateFields}
    }
  }
`;

export const listUserPointsAggregates = /* GraphQL */ `
  query ListUserPointsAggregates($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserPointsAggregates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userPointsAggregateFields} }
      nextToken
    }
  }
`;

export const createUserPointsAggregate = /* GraphQL */ `
  mutation CreateUserPointsAggregate($input: CreateUserPointsAggregateInput!) {
    createUserPointsAggregate(input: $input) {
      ${userPointsAggregateFields}
    }
  }
`;

export const updateUserPointsAggregate = /* GraphQL */ `
  mutation UpdateUserPointsAggregate($input: UpdateUserPointsAggregateInput!) {
    updateUserPointsAggregate(input: $input) {
      ${userPointsAggregateFields}
    }
  }
`;

export const deleteUserPointsAggregate = /* GraphQL */ `
  mutation DeleteUserPointsAggregate($userId: String!) {
    deleteUserPointsAggregate(userId: $userId) {
      ${userPointsAggregateFields}
    }
  }
`;

// ============================================
// ModeratorProfile
// ============================================

const moderatorProfileFields = `id userId role isActive maxDailyDecisions maxHourlyDecisions totalDecisions30d overturnedDecisions30d appealOverturnRate30d avgDecisionTimeSeconds30d createdAt updatedAt`;

export const getModeratorProfile = /* GraphQL */ `
  query GetModeratorProfile($id: ID!) {
    getModeratorProfile(id: $id) {
      ${moderatorProfileFields}
    }
  }
`;

export const listModeratorProfiles = /* GraphQL */ `
  query ListModeratorProfiles($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listModeratorProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${moderatorProfileFields} }
      nextToken
    }
  }
`;

export const createModeratorProfile = /* GraphQL */ `
  mutation CreateModeratorProfile($input: CreateModeratorProfileInput!) {
    createModeratorProfile(input: $input) {
      ${moderatorProfileFields}
    }
  }
`;

export const updateModeratorProfile = /* GraphQL */ `
  mutation UpdateModeratorProfile($input: UpdateModeratorProfileInput!) {
    updateModeratorProfile(input: $input) {
      ${moderatorProfileFields}
    }
  }
`;

export const deleteModeratorProfile = /* GraphQL */ `
  mutation DeleteModeratorProfile($id: ID!) {
    deleteModeratorProfile(id: $id) {
      ${moderatorProfileFields}
    }
  }
`;

// ============================================
// UserHornPreference
// ============================================

const userHornPreferenceFields = `userId owner avgWatchedDurationSec creatorAffinities negativeCreators totalHornsWatched lastUpdatedAt meaningfulInteractions lastActiveAt positiveCreatorCount negativeSignalCount creatorAffinitiesDecayedAt createdAt updatedAt`;

export const getUserHornPreference = /* GraphQL */ `
  query GetUserHornPreference($userId: String!) {
    getUserHornPreference(userId: $userId) {
      ${userHornPreferenceFields}
    }
  }
`;

export const listUserHornPreferences = /* GraphQL */ `
  query ListUserHornPreferences($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserHornPreferences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userHornPreferenceFields} }
      nextToken
    }
  }
`;

export const createUserHornPreference = /* GraphQL */ `
  mutation CreateUserHornPreference($input: CreateUserHornPreferenceInput!) {
    createUserHornPreference(input: $input) {
      ${userHornPreferenceFields}
    }
  }
`;

export const updateUserHornPreference = /* GraphQL */ `
  mutation UpdateUserHornPreference($input: UpdateUserHornPreferenceInput!) {
    updateUserHornPreference(input: $input) {
      ${userHornPreferenceFields}
    }
  }
`;

export const deleteUserHornPreference = /* GraphQL */ `
  mutation DeleteUserHornPreference($userId: String!) {
    deleteUserHornPreference(userId: $userId) {
      ${userHornPreferenceFields}
    }
  }
`;

// ============================================
// Frame
// ============================================

const frameFields = `id name description category tags creatorType creatorId currentVersionId currentVersionHash isActive availableFrom availableUntil supportedCameras visibilityStatus createdAt updatedAt`;

export const getFrame = /* GraphQL */ `
  query GetFrame($id: ID!) {
    getFrame(id: $id) {
      ${frameFields}
    }
  }
`;

export const listFrames = /* GraphQL */ `
  query ListFrames($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFrames(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${frameFields} }
      nextToken
    }
  }
`;

export const createFrame = /* GraphQL */ `
  mutation CreateFrame($input: CreateFrameInput!) {
    createFrame(input: $input) {
      ${frameFields}
    }
  }
`;

export const updateFrame = /* GraphQL */ `
  mutation UpdateFrame($input: UpdateFrameInput!) {
    updateFrame(input: $input) {
      ${frameFields}
    }
  }
`;

export const deleteFrame = /* GraphQL */ `
  mutation DeleteFrame($id: ID!) {
    deleteFrame(id: $id) {
      ${frameFields}
    }
  }
`;

export const framesByVisibility = /* GraphQL */ `
  query FramesByVisibility($visibilityStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    framesByVisibility(visibilityStatus: $visibilityStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${frameFields} }
      nextToken
    }
  }
`;

// ============================================
// Filter
// ============================================

const filterFields = `id name description category tags creatorType creatorId currentVersionId currentVersionHash filterType minDeviceCapability isActive availableFrom availableUntil supportedCameras visibilityStatus createdAt updatedAt`;

export const getFilter = /* GraphQL */ `
  query GetFilter($id: ID!) {
    getFilter(id: $id) {
      ${filterFields}
    }
  }
`;

export const listFilters = /* GraphQL */ `
  query ListFilters($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFilters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${filterFields} }
      nextToken
    }
  }
`;

export const createFilter = /* GraphQL */ `
  mutation CreateFilter($input: CreateFilterInput!) {
    createFilter(input: $input) {
      ${filterFields}
    }
  }
`;

export const updateFilter = /* GraphQL */ `
  mutation UpdateFilter($input: UpdateFilterInput!) {
    updateFilter(input: $input) {
      ${filterFields}
    }
  }
`;

export const deleteFilter = /* GraphQL */ `
  mutation DeleteFilter($id: ID!) {
    deleteFilter(id: $id) {
      ${filterFields}
    }
  }
`;

export const filtersByVisibility = /* GraphQL */ `
  query FiltersByVisibility($visibilityStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    filtersByVisibility(visibilityStatus: $visibilityStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${filterFields} }
      nextToken
    }
  }
`;

// ============================================
// FrameVersion
// ============================================

const frameVersionFields = `id frameId versionNumber contentHash overlayImagePath maskImagePath thumbnailPath aspectRatio safeAreaInsets zOrder blendMode imageWidth imageHeight fileSizeBytes isActive uploadedBy uploadedAt createdAt updatedAt`;

export const getFrameVersion = /* GraphQL */ `
  query GetFrameVersion($id: ID!) {
    getFrameVersion(id: $id) {
      ${frameVersionFields}
    }
  }
`;

export const listFrameVersions = /* GraphQL */ `
  query ListFrameVersions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFrameVersions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${frameVersionFields} }
      nextToken
    }
  }
`;

export const createFrameVersion = /* GraphQL */ `
  mutation CreateFrameVersion($input: CreateFrameVersionInput!) {
    createFrameVersion(input: $input) {
      ${frameVersionFields}
    }
  }
`;

export const updateFrameVersion = /* GraphQL */ `
  mutation UpdateFrameVersion($input: UpdateFrameVersionInput!) {
    updateFrameVersion(input: $input) {
      ${frameVersionFields}
    }
  }
`;

export const deleteFrameVersion = /* GraphQL */ `
  mutation DeleteFrameVersion($id: ID!) {
    deleteFrameVersion(id: $id) {
      ${frameVersionFields}
    }
  }
`;

export const versionsByFrame = /* GraphQL */ `
  query VersionsByFrame($frameId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    versionsByFrame(frameId: $frameId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${frameVersionFields} }
      nextToken
    }
  }
`;

// ============================================
// FilterVersion
// ============================================

const filterVersionFields = `id filterId versionNumber contentHash filterAssetPath thumbnailPath colorSpaceInput colorSpaceOutput parameters maxProcessingTimeMs fileSizeBytes isActive uploadedBy uploadedAt createdAt updatedAt`;

export const getFilterVersion = /* GraphQL */ `
  query GetFilterVersion($id: ID!) {
    getFilterVersion(id: $id) {
      ${filterVersionFields}
    }
  }
`;

export const listFilterVersions = /* GraphQL */ `
  query ListFilterVersions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFilterVersions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${filterVersionFields} }
      nextToken
    }
  }
`;

export const createFilterVersion = /* GraphQL */ `
  mutation CreateFilterVersion($input: CreateFilterVersionInput!) {
    createFilterVersion(input: $input) {
      ${filterVersionFields}
    }
  }
`;

export const updateFilterVersion = /* GraphQL */ `
  mutation UpdateFilterVersion($input: UpdateFilterVersionInput!) {
    updateFilterVersion(input: $input) {
      ${filterVersionFields}
    }
  }
`;

export const deleteFilterVersion = /* GraphQL */ `
  mutation DeleteFilterVersion($id: ID!) {
    deleteFilterVersion(id: $id) {
      ${filterVersionFields}
    }
  }
`;

export const versionsByFilter = /* GraphQL */ `
  query VersionsByFilter($filterId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    versionsByFilter(filterId: $filterId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${filterVersionFields} }
      nextToken
    }
  }
`;

// ============================================
// AppPersona
// ============================================

const appPersonaFields = `id displayName handle avatarUrl bio systemPersona isActive activeStatus postingCapabilities defaultTone defaultMaxPostsPerDay defaultCooldownHours createdBy lastEditedBy lastEditedAt isDeleted deletedAt deletedBy createdAt updatedAt`;

export const getAppPersona = /* GraphQL */ `
  query GetAppPersona($id: ID!) {
    getAppPersona(id: $id) {
      ${appPersonaFields}
    }
  }
`;

export const listAppPersonas = /* GraphQL */ `
  query ListAppPersonas($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listAppPersonas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${appPersonaFields} }
      nextToken
    }
  }
`;

export const createAppPersona = /* GraphQL */ `
  mutation CreateAppPersona($input: CreateAppPersonaInput!) {
    createAppPersona(input: $input) {
      ${appPersonaFields}
    }
  }
`;

export const updateAppPersona = /* GraphQL */ `
  mutation UpdateAppPersona($input: UpdateAppPersonaInput!) {
    updateAppPersona(input: $input) {
      ${appPersonaFields}
    }
  }
`;

export const deleteAppPersona = /* GraphQL */ `
  mutation DeleteAppPersona($id: ID!) {
    deleteAppPersona(id: $id) {
      ${appPersonaFields}
    }
  }
`;

// ============================================
// UserModerationHistory
// ============================================

const userModerationHistoryFields = `id owner userId actionType caseId reason duration expiresAt issuedBy appealStatus appealedAt appealReviewedBy appealReviewedAt createdAt updatedAt`;

export const getUserModerationHistory = /* GraphQL */ `
  query GetUserModerationHistory($id: ID!) {
    getUserModerationHistory(id: $id) {
      ${userModerationHistoryFields}
    }
  }
`;

export const listUserModerationHistories = /* GraphQL */ `
  query ListUserModerationHistories($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserModerationHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userModerationHistoryFields} }
      nextToken
    }
  }
`;

export const createUserModerationHistory = /* GraphQL */ `
  mutation CreateUserModerationHistory($input: CreateUserModerationHistoryInput!) {
    createUserModerationHistory(input: $input) {
      ${userModerationHistoryFields}
    }
  }
`;

export const updateUserModerationHistory = /* GraphQL */ `
  mutation UpdateUserModerationHistory($input: UpdateUserModerationHistoryInput!) {
    updateUserModerationHistory(input: $input) {
      ${userModerationHistoryFields}
    }
  }
`;

export const deleteUserModerationHistory = /* GraphQL */ `
  mutation DeleteUserModerationHistory($id: ID!) {
    deleteUserModerationHistory(id: $id) {
      ${userModerationHistoryFields}
    }
  }
`;

// ============================================
// ContentHiddenFromUser
// ============================================

const contentHiddenFromUserFields = `id owner userId contentType contentId reason userContentKey createdAt updatedAt`;

export const getContentHiddenFromUser = /* GraphQL */ `
  query GetContentHiddenFromUser($id: ID!) {
    getContentHiddenFromUser(id: $id) {
      ${contentHiddenFromUserFields}
    }
  }
`;

export const listContentHiddenFromUsers = /* GraphQL */ `
  query ListContentHiddenFromUsers($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listContentHiddenFromUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${contentHiddenFromUserFields} }
      nextToken
    }
  }
`;

export const createContentHiddenFromUser = /* GraphQL */ `
  mutation CreateContentHiddenFromUser($input: CreateContentHiddenFromUserInput!) {
    createContentHiddenFromUser(input: $input) {
      ${contentHiddenFromUserFields}
    }
  }
`;

export const updateContentHiddenFromUser = /* GraphQL */ `
  mutation UpdateContentHiddenFromUser($input: UpdateContentHiddenFromUserInput!) {
    updateContentHiddenFromUser(input: $input) {
      ${contentHiddenFromUserFields}
    }
  }
`;

export const deleteContentHiddenFromUser = /* GraphQL */ `
  mutation DeleteContentHiddenFromUser($id: ID!) {
    deleteContentHiddenFromUser(id: $id) {
      ${contentHiddenFromUserFields}
    }
  }
`;

export const hiddenContentByUser = /* GraphQL */ `
  query HiddenContentByUser($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    hiddenContentByUser(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${contentHiddenFromUserFields} }
      nextToken
    }
  }
`;

// ============================================
// ScreenCaptureEvent
// ============================================

const screenCaptureEventFields = `id owner contentType contentId ownerUserId viewerUserId timestamp createdAt updatedAt`;

export const getScreenCaptureEvent = /* GraphQL */ `
  query GetScreenCaptureEvent($id: ID!) {
    getScreenCaptureEvent(id: $id) {
      ${screenCaptureEventFields}
    }
  }
`;

export const listScreenCaptureEvents = /* GraphQL */ `
  query ListScreenCaptureEvents($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listScreenCaptureEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${screenCaptureEventFields} }
      nextToken
    }
  }
`;

export const createScreenCaptureEvent = /* GraphQL */ `
  mutation CreateScreenCaptureEvent($input: CreateScreenCaptureEventInput!) {
    createScreenCaptureEvent(input: $input) {
      ${screenCaptureEventFields}
    }
  }
`;

export const updateScreenCaptureEvent = /* GraphQL */ `
  mutation UpdateScreenCaptureEvent($input: UpdateScreenCaptureEventInput!) {
    updateScreenCaptureEvent(input: $input) {
      ${screenCaptureEventFields}
    }
  }
`;

export const deleteScreenCaptureEvent = /* GraphQL */ `
  mutation DeleteScreenCaptureEvent($id: ID!) {
    deleteScreenCaptureEvent(id: $id) {
      ${screenCaptureEventFields}
    }
  }
`;

// GSI: listScreenCaptureEventByContentId
export const listScreenCaptureEventByContentId = /* GraphQL */ `
  query ListScreenCaptureEventByContentId($contentId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listScreenCaptureEventByContentId(contentId: $contentId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${screenCaptureEventFields} }
      nextToken
    }
  }
`;

// ============================================
// UserTrust
// ============================================

const userTrustFields = `id userId trustScore flagsSubmitted30d flagsUpheld30d flagsRejected30d contentRemoved30d flagsToday flagsThisHour lastFlagAt isShadowBanned isRestricted restrictedUntil createdAt updatedAt`;

export const getUserTrust = /* GraphQL */ `
  query GetUserTrust($id: ID!) {
    getUserTrust(id: $id) {
      ${userTrustFields}
    }
  }
`;

export const listUserTrusts = /* GraphQL */ `
  query ListUserTrusts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserTrusts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userTrustFields} }
      nextToken
    }
  }
`;

export const createUserTrust = /* GraphQL */ `
  mutation CreateUserTrust($input: CreateUserTrustInput!) {
    createUserTrust(input: $input) {
      ${userTrustFields}
    }
  }
`;

export const updateUserTrust = /* GraphQL */ `
  mutation UpdateUserTrust($input: UpdateUserTrustInput!) {
    updateUserTrust(input: $input) {
      ${userTrustFields}
    }
  }
`;

export const deleteUserTrust = /* GraphQL */ `
  mutation DeleteUserTrust($id: ID!) {
    deleteUserTrust(id: $id) {
      ${userTrustFields}
    }
  }
`;

export const trustByUserId = /* GraphQL */ `
  query TrustByUserId($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    trustByUserId(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${userTrustFields} }
      nextToken
    }
  }
`;

// ============================================
// ModerationMediaAccessLog
// ============================================

const moderationMediaAccessLogFields = `id moderatorUserId contentType contentId mediaKey action reason decision denialReason requestId userAgent createdAt updatedAt`;

export const getModerationMediaAccessLog = /* GraphQL */ `
  query GetModerationMediaAccessLog($id: ID!) {
    getModerationMediaAccessLog(id: $id) {
      ${moderationMediaAccessLogFields}
    }
  }
`;

export const listModerationMediaAccessLogs = /* GraphQL */ `
  query ListModerationMediaAccessLogs($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listModerationMediaAccessLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${moderationMediaAccessLogFields} }
      nextToken
    }
  }
`;

export const createModerationMediaAccessLog = /* GraphQL */ `
  mutation CreateModerationMediaAccessLog($input: CreateModerationMediaAccessLogInput!) {
    createModerationMediaAccessLog(input: $input) {
      ${moderationMediaAccessLogFields}
    }
  }
`;

export const updateModerationMediaAccessLog = /* GraphQL */ `
  mutation UpdateModerationMediaAccessLog($input: UpdateModerationMediaAccessLogInput!) {
    updateModerationMediaAccessLog(input: $input) {
      ${moderationMediaAccessLogFields}
    }
  }
`;

export const deleteModerationMediaAccessLog = /* GraphQL */ `
  mutation DeleteModerationMediaAccessLog($id: ID!) {
    deleteModerationMediaAccessLog(id: $id) {
      ${moderationMediaAccessLogFields}
    }
  }
`;

// ============================================
// LoadingScreen
// ============================================

const loadingScreenFields = `id imageS3Key overlayText textPosition theme isActive weight createdBy createdAt updatedAt`;

export const getLoadingScreen = /* GraphQL */ `
  query GetLoadingScreen($id: ID!) {
    getLoadingScreen(id: $id) {
      ${loadingScreenFields}
    }
  }
`;

export const listLoadingScreens = /* GraphQL */ `
  query ListLoadingScreens($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listLoadingScreens(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${loadingScreenFields} }
      nextToken
    }
  }
`;

export const createLoadingScreen = /* GraphQL */ `
  mutation CreateLoadingScreen($input: CreateLoadingScreenInput!) {
    createLoadingScreen(input: $input) {
      ${loadingScreenFields}
    }
  }
`;

export const updateLoadingScreen = /* GraphQL */ `
  mutation UpdateLoadingScreen($input: UpdateLoadingScreenInput!) {
    updateLoadingScreen(input: $input) {
      ${loadingScreenFields}
    }
  }
`;

export const deleteLoadingScreen = /* GraphQL */ `
  mutation DeleteLoadingScreen($id: ID!) {
    deleteLoadingScreen(id: $id) {
      ${loadingScreenFields}
    }
  }
`;

// GSI: activeLoadingScreens
export const activeLoadingScreens = /* GraphQL */ `
  query ActiveLoadingScreens($isActive: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    activeLoadingScreens(isActive: $isActive, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${loadingScreenFields} }
      nextToken
    }
  }
`;

// ============================================
// PromptSuggestionAudit
// ============================================

const promptSuggestionAuditFields = `id suggestionId actorId actorEmail actionType timestamp previousValue newValue changeReason createdAt updatedAt`;

export const getPromptSuggestionAudit = /* GraphQL */ `
  query GetPromptSuggestionAudit($id: ID!) {
    getPromptSuggestionAudit(id: $id) {
      ${promptSuggestionAuditFields}
    }
  }
`;

export const listPromptSuggestionAudits = /* GraphQL */ `
  query ListPromptSuggestionAudits($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPromptSuggestionAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${promptSuggestionAuditFields} }
      nextToken
    }
  }
`;

export const createPromptSuggestionAudit = /* GraphQL */ `
  mutation CreatePromptSuggestionAudit($input: CreatePromptSuggestionAuditInput!) {
    createPromptSuggestionAudit(input: $input) {
      ${promptSuggestionAuditFields}
    }
  }
`;

export const updatePromptSuggestionAudit = /* GraphQL */ `
  mutation UpdatePromptSuggestionAudit($input: UpdatePromptSuggestionAuditInput!) {
    updatePromptSuggestionAudit(input: $input) {
      ${promptSuggestionAuditFields}
    }
  }
`;

export const deletePromptSuggestionAudit = /* GraphQL */ `
  mutation DeletePromptSuggestionAudit($id: ID!) {
    deletePromptSuggestionAudit(id: $id) {
      ${promptSuggestionAuditFields}
    }
  }
`;

// GSI: auditBySuggestion
export const auditBySuggestion = /* GraphQL */ `
  query AuditBySuggestion($suggestionId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    auditBySuggestion(suggestionId: $suggestionId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionAuditFields} }
      nextToken
    }
  }
`;

// ============================================
// Batch 2 models (from model-configs-2.ts)
// ============================================

// ── UserProfile ──

const userProfileFields = `id owner handle displayName avatarUrl email phoneNumber bio websiteUrl isPrivate isBlueCheck isPremium premiumSource premiumGrantedAt iapProductId iapExpiresAt iapOriginalTransactionId totalContentCreated referralCount referredByUserId followerCount followingCount ageVerificationStatus isAgeVerified ageTier moderationCaseId createdAt updatedAt`;

export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      ${userProfileFields}
    }
  }
`;

export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${userProfileFields} }
      nextToken
    }
  }
`;

export const profileByHandle = /* GraphQL */ `
  query ProfileByHandle($handle: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    profileByHandle(handle: $handle, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${userProfileFields} }
      nextToken
    }
  }
`;

export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile($input: CreateUserProfileInput!) {
    createUserProfile(input: $input) {
      ${userProfileFields}
    }
  }
`;

export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      ${userProfileFields}
    }
  }
`;

export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile($id: ID!) {
    deleteUserProfile(id: $id) {
      ${userProfileFields}
    }
  }
`;


// ── Follow ──

const followFields = `id owner followerId followingId createdAt updatedAt`;

export const getFollow = /* GraphQL */ `
  query GetFollow($id: ID!) {
    getFollow(id: $id) {
      ${followFields}
    }
  }
`;

export const listFollows = /* GraphQL */ `
  query ListFollows($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFollows(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${followFields} }
      nextToken
    }
  }
`;

export const createFollow = /* GraphQL */ `
  mutation CreateFollow($input: CreateFollowInput!) {
    createFollow(input: $input) {
      ${followFields}
    }
  }
`;

export const updateFollow = /* GraphQL */ `
  mutation UpdateFollow($input: UpdateFollowInput!) {
    updateFollow(input: $input) {
      ${followFields}
    }
  }
`;

export const deleteFollow = /* GraphQL */ `
  mutation DeleteFollow($id: ID!) {
    deleteFollow(id: $id) {
      ${followFields}
    }
  }
`;


// ── Prompt ──

const promptFields = `id owner creatorUserId audienceType targetUserIds targetGroupIds text promptType frameId frameVersionId frameVersionHash filterId filterVersionId filterVersionHash requiredCamera expiresAt visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId postedByPersonaId source automationRuleId automationSuggestionId primaryCamera submitterResponseId publishedAt allowedResponseTypes createdAt updatedAt`;

export const getPrompt = /* GraphQL */ `
  query GetPrompt($id: ID!) {
    getPrompt(id: $id) {
      ${promptFields}
    }
  }
`;

export const listPrompts = /* GraphQL */ `
  query ListPrompts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPrompts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${promptFields} }
      nextToken
    }
  }
`;

export const createPrompt = /* GraphQL */ `
  mutation CreatePrompt($input: CreatePromptInput!) {
    createPrompt(input: $input) {
      ${promptFields}
    }
  }
`;

export const updatePrompt = /* GraphQL */ `
  mutation UpdatePrompt($input: UpdatePromptInput!) {
    updatePrompt(input: $input) {
      ${promptFields}
    }
  }
`;

export const deletePrompt = /* GraphQL */ `
  mutation DeletePrompt($id: ID!) {
    deletePrompt(id: $id) {
      ${promptFields}
    }
  }
`;

export const promptByCreatorUserId = /* GraphQL */ `
  query PromptByCreatorUserId($creatorUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptByCreatorUserId(creatorUserId: $creatorUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptFields} }
      nextToken
    }
  }
`;

export const promptByFrameId = /* GraphQL */ `
  query PromptByFrameId($frameId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptByFrameId(frameId: $frameId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptFields} }
      nextToken
    }
  }
`;

export const promptByFilterId = /* GraphQL */ `
  query PromptByFilterId($filterId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptByFilterId(filterId: $filterId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptFields} }
      nextToken
    }
  }
`;

export const promptByVisibilityStatus = /* GraphQL */ `
  query PromptByVisibilityStatus($visibilityStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptByVisibilityStatus(visibilityStatus: $visibilityStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptFields} }
      nextToken
    }
  }
`;

export const promptByPostedByPersonaId = /* GraphQL */ `
  query PromptByPostedByPersonaId($postedByPersonaId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptByPostedByPersonaId(postedByPersonaId: $postedByPersonaId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptFields} }
      nextToken
    }
  }
`;

export const promptBySource = /* GraphQL */ `
  query PromptBySource($source: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptBySource(source: $source, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptFields} }
      nextToken
    }
  }
`;


// ── Post ──

const postFields = `id owner creatorUserId audienceType targetUserIds targetGroupIds textContent mediaAttachments externalUrl hashtags reactionCount commentCount shareCount visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId isDeleted deletedAt editedAt editCount publishedAt createdAt updatedAt`;

export const getPost = /* GraphQL */ `
  query GetPost($id: ID!) {
    getPost(id: $id) {
      ${postFields}
    }
  }
`;

export const listPosts = /* GraphQL */ `
  query ListPosts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${postFields} }
      nextToken
    }
  }
`;

export const createPost = /* GraphQL */ `
  mutation CreatePost($input: CreatePostInput!) {
    createPost(input: $input) {
      ${postFields}
    }
  }
`;

export const updatePost = /* GraphQL */ `
  mutation UpdatePost($input: UpdatePostInput!) {
    updatePost(input: $input) {
      ${postFields}
    }
  }
`;

export const deletePost = /* GraphQL */ `
  mutation DeletePost($id: ID!) {
    deletePost(id: $id) {
      ${postFields}
    }
  }
`;

export const postsByCreator = /* GraphQL */ `
  query PostsByCreator($creatorUserId: String!, $publishedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    postsByCreator(creatorUserId: $creatorUserId, publishedAt: $publishedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postFields} }
      nextToken
    }
  }
`;

export const postsByVisibility = /* GraphQL */ `
  query PostsByVisibility($visibilityStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    postsByVisibility(visibilityStatus: $visibilityStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postFields} }
      nextToken
    }
  }
`;


// ── PostComment ──

const postCommentFields = `id owner postId commenterUserId text likeCount visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId parentCommentId replyCount commentedAt createdAt updatedAt`;

export const getPostComment = /* GraphQL */ `
  query GetPostComment($id: ID!) {
    getPostComment(id: $id) {
      ${postCommentFields}
    }
  }
`;

export const listPostComments = /* GraphQL */ `
  query ListPostComments($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPostComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${postCommentFields} }
      nextToken
    }
  }
`;

export const createPostComment = /* GraphQL */ `
  mutation CreatePostComment($input: CreatePostCommentInput!) {
    createPostComment(input: $input) {
      ${postCommentFields}
    }
  }
`;

export const updatePostComment = /* GraphQL */ `
  mutation UpdatePostComment($input: UpdatePostCommentInput!) {
    updatePostComment(input: $input) {
      ${postCommentFields}
    }
  }
`;

export const deletePostComment = /* GraphQL */ `
  mutation DeletePostComment($id: ID!) {
    deletePostComment(id: $id) {
      ${postCommentFields}
    }
  }
`;

export const commentsByPost = /* GraphQL */ `
  query CommentsByPost($postId: String!, $commentedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    commentsByPost(postId: $postId, commentedAt: $commentedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postCommentFields} }
      nextToken
    }
  }
`;

export const commentRepliesByPost = /* GraphQL */ `
  query CommentRepliesByPost($parentCommentId: String!, $commentedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    commentRepliesByPost(parentCommentId: $parentCommentId, commentedAt: $commentedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postCommentFields} }
      nextToken
    }
  }
`;


// ── PostReaction ──

const postReactionFields = `id owner postId reactorUserId emoji reactedAt createdAt updatedAt`;

export const getPostReaction = /* GraphQL */ `
  query GetPostReaction($id: ID!) {
    getPostReaction(id: $id) {
      ${postReactionFields}
    }
  }
`;

export const listPostReactions = /* GraphQL */ `
  query ListPostReactions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPostReactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${postReactionFields} }
      nextToken
    }
  }
`;

export const createPostReaction = /* GraphQL */ `
  mutation CreatePostReaction($input: CreatePostReactionInput!) {
    createPostReaction(input: $input) {
      ${postReactionFields}
    }
  }
`;

export const updatePostReaction = /* GraphQL */ `
  mutation UpdatePostReaction($input: UpdatePostReactionInput!) {
    updatePostReaction(input: $input) {
      ${postReactionFields}
    }
  }
`;

export const deletePostReaction = /* GraphQL */ `
  mutation DeletePostReaction($id: ID!) {
    deletePostReaction(id: $id) {
      ${postReactionFields}
    }
  }
`;

export const reactionsByPost = /* GraphQL */ `
  query ReactionsByPost($postId: String!, $reactedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    reactionsByPost(postId: $postId, reactedAt: $reactedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postReactionFields} }
      nextToken
    }
  }
`;


// ── Response ──

const responseFields = `id owner promptId responderUserId responseType frontPhotoUrl backPhotoUrl photoUrl videoUrl videoDuration videoThumbnailUrl cameraUsed aspectRatio mediaWidth mediaHeight locationCity likeCount isAnonymous appliedFrameId appliedFrameVersionId appliedFrameVersionHash appliedFilterId appliedFilterVersionId appliedFilterVersionHash captureIntegrityHash visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId createdAt updatedAt`;

export const getResponse = /* GraphQL */ `
  query GetResponse($id: ID!) {
    getResponse(id: $id) {
      ${responseFields}
    }
  }
`;

export const listResponses = /* GraphQL */ `
  query ListResponses($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listResponses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${responseFields} }
      nextToken
    }
  }
`;

export const createResponse = /* GraphQL */ `
  mutation CreateResponse($input: CreateResponseInput!) {
    createResponse(input: $input) {
      ${responseFields}
    }
  }
`;

export const updateResponse = /* GraphQL */ `
  mutation UpdateResponse($input: UpdateResponseInput!) {
    updateResponse(input: $input) {
      ${responseFields}
    }
  }
`;

export const deleteResponse = /* GraphQL */ `
  mutation DeleteResponse($id: ID!) {
    deleteResponse(id: $id) {
      ${responseFields}
    }
  }
`;

export const responseByPromptId = /* GraphQL */ `
  query ResponseByPromptId($promptId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    responseByPromptId(promptId: $promptId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseFields} }
      nextToken
    }
  }
`;

export const responseByResponderUserId = /* GraphQL */ `
  query ResponseByResponderUserId($responderUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    responseByResponderUserId(responderUserId: $responderUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseFields} }
      nextToken
    }
  }
`;

export const responseByAppliedFrameId = /* GraphQL */ `
  query ResponseByAppliedFrameId($appliedFrameId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    responseByAppliedFrameId(appliedFrameId: $appliedFrameId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseFields} }
      nextToken
    }
  }
`;

export const responseByAppliedFilterId = /* GraphQL */ `
  query ResponseByAppliedFilterId($appliedFilterId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    responseByAppliedFilterId(appliedFilterId: $appliedFilterId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseFields} }
      nextToken
    }
  }
`;

export const responseByVisibilityStatus = /* GraphQL */ `
  query ResponseByVisibilityStatus($visibilityStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    responseByVisibilityStatus(visibilityStatus: $visibilityStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseFields} }
      nextToken
    }
  }
`;


// ── ResponseView ──

const responseViewFields = `id owner promptId responseId viewerId viewedAt createdAt updatedAt`;

export const getResponseView = /* GraphQL */ `
  query GetResponseView($id: ID!) {
    getResponseView(id: $id) {
      ${responseViewFields}
    }
  }
`;

export const listResponseViews = /* GraphQL */ `
  query ListResponseViews($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listResponseViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${responseViewFields} }
      nextToken
    }
  }
`;

export const createResponseView = /* GraphQL */ `
  mutation CreateResponseView($input: CreateResponseViewInput!) {
    createResponseView(input: $input) {
      ${responseViewFields}
    }
  }
`;

export const updateResponseView = /* GraphQL */ `
  mutation UpdateResponseView($input: UpdateResponseViewInput!) {
    updateResponseView(input: $input) {
      ${responseViewFields}
    }
  }
`;

export const deleteResponseView = /* GraphQL */ `
  mutation DeleteResponseView($id: ID!) {
    deleteResponseView(id: $id) {
      ${responseViewFields}
    }
  }
`;

export const listResponseViewsByPrompt = /* GraphQL */ `
  query ListResponseViewsByPrompt($promptId: String!, $viewedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listResponseViewsByPrompt(promptId: $promptId, viewedAt: $viewedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseViewFields} }
      nextToken
    }
  }
`;

export const listResponseViewsByViewer = /* GraphQL */ `
  query ListResponseViewsByViewer($viewerId: String!, $viewedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listResponseViewsByViewer(viewerId: $viewerId, viewedAt: $viewedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseViewFields} }
      nextToken
    }
  }
`;

export const listResponseViewsByResponse = /* GraphQL */ `
  query ListResponseViewsByResponse($responseId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listResponseViewsByResponse(responseId: $responseId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${responseViewFields} }
      nextToken
    }
  }
`;


// ── Reaction ──

const reactionFields = `id owner responseId userId type createdAt updatedAt`;

export const getReaction = /* GraphQL */ `
  query GetReaction($id: ID!) {
    getReaction(id: $id) {
      ${reactionFields}
    }
  }
`;

export const listReactions = /* GraphQL */ `
  query ListReactions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listReactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${reactionFields} }
      nextToken
    }
  }
`;

export const createReaction = /* GraphQL */ `
  mutation CreateReaction($input: CreateReactionInput!) {
    createReaction(input: $input) {
      ${reactionFields}
    }
  }
`;

export const updateReaction = /* GraphQL */ `
  mutation UpdateReaction($input: UpdateReactionInput!) {
    updateReaction(input: $input) {
      ${reactionFields}
    }
  }
`;

export const deleteReaction = /* GraphQL */ `
  mutation DeleteReaction($id: ID!) {
    deleteReaction(id: $id) {
      ${reactionFields}
    }
  }
`;

export const reactionByResponseId = /* GraphQL */ `
  query ReactionByResponseId($responseId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    reactionByResponseId(responseId: $responseId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${reactionFields} }
      nextToken
    }
  }
`;

export const reactionByUserId = /* GraphQL */ `
  query ReactionByUserId($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    reactionByUserId(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${reactionFields} }
      nextToken
    }
  }
`;


// ── Conversation ──

const conversationFields = `id owner participantIds lastMessageAt isEncrypted encryptionVersion isGroup conversationType groupName groupDescription groupAvatarUrl createdByUserId isDirectPromptGroup groupEncryptionKeyId groupKeyVersion memberCount maxMembers disappearingMessagesEnabled messageTTLHours disappearingMessagesDisclosureShown createdAt updatedAt`;

export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      ${conversationFields}
    }
  }
`;

export const listConversations = /* GraphQL */ `
  query ListConversations($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${conversationFields} }
      nextToken
    }
  }
`;

export const createConversation = /* GraphQL */ `
  mutation CreateConversation($input: CreateConversationInput!) {
    createConversation(input: $input) {
      ${conversationFields}
    }
  }
`;

export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation($input: UpdateConversationInput!) {
    updateConversation(input: $input) {
      ${conversationFields}
    }
  }
`;

export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation($id: ID!) {
    deleteConversation(id: $id) {
      ${conversationFields}
    }
  }
`;

export const listConversationsByType = /* GraphQL */ `
  query ListConversationsByType($conversationType: String!, $lastMessageAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listConversationsByType(conversationType: $conversationType, lastMessageAt: $lastMessageAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${conversationFields} }
      nextToken
    }
  }
`;

export const conversationsByCreator = /* GraphQL */ `
  query ConversationsByCreator($createdByUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    conversationsByCreator(createdByUserId: $createdByUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${conversationFields} }
      nextToken
    }
  }
`;


// ── ConversationArchive ──

const conversationArchiveFields = `conversationId userId owner archivedAt createdAt updatedAt`;

export const getConversationArchive = /* GraphQL */ `
  query GetConversationArchive($conversationId: String!, $userId: String!) {
    getConversationArchive(conversationId: $conversationId, userId: $userId) {
      ${conversationArchiveFields}
    }
  }
`;

export const listConversationArchives = /* GraphQL */ `
  query ListConversationArchives($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listConversationArchives(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${conversationArchiveFields} }
      nextToken
    }
  }
`;

export const createConversationArchive = /* GraphQL */ `
  mutation CreateConversationArchive($input: CreateConversationArchiveInput!) {
    createConversationArchive(input: $input) {
      ${conversationArchiveFields}
    }
  }
`;

export const deleteConversationArchive = /* GraphQL */ `
  mutation DeleteConversationArchive($conversationId: String!, $userId: String!) {
    deleteConversationArchive(conversationId: $conversationId, userId: $userId) {
      ${conversationArchiveFields}
    }
  }
`;

export const archivesByUser = /* GraphQL */ `
  query ArchivesByUser($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    archivesByUser(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${conversationArchiveFields} }
      nextToken
    }
  }
`;


// ── GroupMembership ──

const groupMembershipFields = `conversationId userId owner role joinedAt invitedByUserId isActive leftAt removedByUserId isMuted mutedUntil hasCurrentKey keyVersion createdAt updatedAt`;

export const getGroupMembership = /* GraphQL */ `
  query GetGroupMembership($conversationId: String!, $userId: String!) {
    getGroupMembership(conversationId: $conversationId, userId: $userId) {
      ${groupMembershipFields}
    }
  }
`;

export const listGroupMemberships = /* GraphQL */ `
  query ListGroupMemberships($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listGroupMemberships(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${groupMembershipFields} }
      nextToken
    }
  }
`;

export const createGroupMembership = /* GraphQL */ `
  mutation CreateGroupMembership($input: CreateGroupMembershipInput!) {
    createGroupMembership(input: $input) {
      ${groupMembershipFields}
    }
  }
`;

export const updateGroupMembership = /* GraphQL */ `
  mutation UpdateGroupMembership($input: UpdateGroupMembershipInput!) {
    updateGroupMembership(input: $input) {
      ${groupMembershipFields}
    }
  }
`;

export const deleteGroupMembership = /* GraphQL */ `
  mutation DeleteGroupMembership($conversationId: String!, $userId: String!) {
    deleteGroupMembership(conversationId: $conversationId, userId: $userId) {
      ${groupMembershipFields}
    }
  }
`;

export const membershipsByUser = /* GraphQL */ `
  query MembershipsByUser($userId: String!, $joinedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    membershipsByUser(userId: $userId, joinedAt: $joinedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${groupMembershipFields} }
      nextToken
    }
  }
`;

export const membersByConversation = /* GraphQL */ `
  query MembersByConversation($conversationId: String!, $joinedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    membersByConversation(conversationId: $conversationId, joinedAt: $joinedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${groupMembershipFields} }
      nextToken
    }
  }
`;


// ── SystemEvent ──

const systemEventFields = `id conversationId eventType actorUserId payload createdAt isImmutable updatedAt`;

export const getSystemEvent = /* GraphQL */ `
  query GetSystemEvent($id: ID!) {
    getSystemEvent(id: $id) {
      ${systemEventFields}
    }
  }
`;

export const listSystemEvents = /* GraphQL */ `
  query ListSystemEvents($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listSystemEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${systemEventFields} }
      nextToken
    }
  }
`;

export const createSystemEvent = /* GraphQL */ `
  mutation CreateSystemEvent($input: CreateSystemEventInput!) {
    createSystemEvent(input: $input) {
      ${systemEventFields}
    }
  }
`;

export const updateSystemEvent = /* GraphQL */ `
  mutation UpdateSystemEvent($input: UpdateSystemEventInput!) {
    updateSystemEvent(input: $input) {
      ${systemEventFields}
    }
  }
`;

export const deleteSystemEvent = /* GraphQL */ `
  mutation DeleteSystemEvent($id: ID!) {
    deleteSystemEvent(id: $id) {
      ${systemEventFields}
    }
  }
`;

export const eventsByConversation = /* GraphQL */ `
  query EventsByConversation($conversationId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    eventsByConversation(conversationId: $conversationId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${systemEventFields} }
      nextToken
    }
  }
`;


// ── GroupEncryptionKey ──

const groupEncryptionKeyFields = `id conversationId version encryptedKeys algorithm createdByUserId createdAt rotationReason isActive deprecatedAt updatedAt`;

export const getGroupEncryptionKey = /* GraphQL */ `
  query GetGroupEncryptionKey($id: ID!) {
    getGroupEncryptionKey(id: $id) {
      ${groupEncryptionKeyFields}
    }
  }
`;

export const listGroupEncryptionKeys = /* GraphQL */ `
  query ListGroupEncryptionKeys($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listGroupEncryptionKeys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${groupEncryptionKeyFields} }
      nextToken
    }
  }
`;

export const createGroupEncryptionKey = /* GraphQL */ `
  mutation CreateGroupEncryptionKey($input: CreateGroupEncryptionKeyInput!) {
    createGroupEncryptionKey(input: $input) {
      ${groupEncryptionKeyFields}
    }
  }
`;

export const updateGroupEncryptionKey = /* GraphQL */ `
  mutation UpdateGroupEncryptionKey($input: UpdateGroupEncryptionKeyInput!) {
    updateGroupEncryptionKey(input: $input) {
      ${groupEncryptionKeyFields}
    }
  }
`;

export const deleteGroupEncryptionKey = /* GraphQL */ `
  mutation DeleteGroupEncryptionKey($id: ID!) {
    deleteGroupEncryptionKey(id: $id) {
      ${groupEncryptionKeyFields}
    }
  }
`;

export const keysByConversation = /* GraphQL */ `
  query KeysByConversation($conversationId: String!, $version: Int, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    keysByConversation(conversationId: $conversationId, version: $version, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${groupEncryptionKeyFields} }
      nextToken
    }
  }
`;


// ── GroupPrompt ──

const groupPromptFields = `id owner conversationId promptId promptText promptType promptSource senderUserId createdAt expiresAt responseCount lastResponseAt updatedAt`;

export const getGroupPrompt = /* GraphQL */ `
  query GetGroupPrompt($id: ID!) {
    getGroupPrompt(id: $id) {
      ${groupPromptFields}
    }
  }
`;

export const listGroupPrompts = /* GraphQL */ `
  query ListGroupPrompts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listGroupPrompts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${groupPromptFields} }
      nextToken
    }
  }
`;

export const createGroupPrompt = /* GraphQL */ `
  mutation CreateGroupPrompt($input: CreateGroupPromptInput!) {
    createGroupPrompt(input: $input) {
      ${groupPromptFields}
    }
  }
`;

export const updateGroupPrompt = /* GraphQL */ `
  mutation UpdateGroupPrompt($input: UpdateGroupPromptInput!) {
    updateGroupPrompt(input: $input) {
      ${groupPromptFields}
    }
  }
`;

export const deleteGroupPrompt = /* GraphQL */ `
  mutation DeleteGroupPrompt($id: ID!) {
    deleteGroupPrompt(id: $id) {
      ${groupPromptFields}
    }
  }
`;

export const promptsByConversation = /* GraphQL */ `
  query PromptsByConversation($conversationId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    promptsByConversation(conversationId: $conversationId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${groupPromptFields} }
      nextToken
    }
  }
`;

export const groupsByPrompt = /* GraphQL */ `
  query GroupsByPrompt($promptId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    groupsByPrompt(promptId: $promptId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${groupPromptFields} }
      nextToken
    }
  }
`;


// ── Message ──

const messageFields = `id owner conversationId senderId text isDeleted deletedAt deletedBy expiresAt expiresAtEpoch isEphemeral createdAt updatedAt`;

export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      ${messageFields}
    }
  }
`;

export const listMessages = /* GraphQL */ `
  query ListMessages($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${messageFields} }
      nextToken
    }
  }
`;

export const createMessage = /* GraphQL */ `
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      ${messageFields}
    }
  }
`;

export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      ${messageFields}
    }
  }
`;

export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage($id: ID!) {
    deleteMessage(id: $id) {
      ${messageFields}
    }
  }
`;

export const messageByConversationId = /* GraphQL */ `
  query MessageByConversationId($conversationId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    messageByConversationId(conversationId: $conversationId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageFields} }
      nextToken
    }
  }
`;

export const legacyMessagesByExpiry = /* GraphQL */ `
  query LegacyMessagesByExpiry($expiresAt: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    legacyMessagesByExpiry(expiresAt: $expiresAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageFields} }
      nextToken
    }
  }
`;


// ── EncryptedMessage ──

const encryptedMessageFields = `id owner conversationId senderId senderDeviceId recipientDeviceId ciphertext nonce messageGroupId messageType isDeleted deletedAt editedAt visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId replyToMessageId replyToMessageGroupId replyPreviewText replyToSenderId expiresAt expiresAtEpoch isEphemeral createdAt updatedAt`;

export const getEncryptedMessage = /* GraphQL */ `
  query GetEncryptedMessage($id: ID!) {
    getEncryptedMessage(id: $id) {
      ${encryptedMessageFields}
    }
  }
`;

export const listEncryptedMessages = /* GraphQL */ `
  query ListEncryptedMessages($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listEncryptedMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${encryptedMessageFields} }
      nextToken
    }
  }
`;

export const createEncryptedMessage = /* GraphQL */ `
  mutation CreateEncryptedMessage($input: CreateEncryptedMessageInput!) {
    createEncryptedMessage(input: $input) {
      ${encryptedMessageFields}
    }
  }
`;

export const updateEncryptedMessage = /* GraphQL */ `
  mutation UpdateEncryptedMessage($input: UpdateEncryptedMessageInput!) {
    updateEncryptedMessage(input: $input) {
      ${encryptedMessageFields}
    }
  }
`;

export const deleteEncryptedMessage = /* GraphQL */ `
  mutation DeleteEncryptedMessage($id: ID!) {
    deleteEncryptedMessage(id: $id) {
      ${encryptedMessageFields}
    }
  }
`;

export const encryptedMessageByConversationId = /* GraphQL */ `
  query EncryptedMessageByConversationId($conversationId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    encryptedMessageByConversationId(conversationId: $conversationId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${encryptedMessageFields} }
      nextToken
    }
  }
`;

export const encryptedMessageByRecipientDeviceId = /* GraphQL */ `
  query EncryptedMessageByRecipientDeviceId($recipientDeviceId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    encryptedMessageByRecipientDeviceId(recipientDeviceId: $recipientDeviceId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${encryptedMessageFields} }
      nextToken
    }
  }
`;

export const encryptedMessageByMessageGroupId = /* GraphQL */ `
  query EncryptedMessageByMessageGroupId($messageGroupId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    encryptedMessageByMessageGroupId(messageGroupId: $messageGroupId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${encryptedMessageFields} }
      nextToken
    }
  }
`;

export const messagesByExpiry = /* GraphQL */ `
  query MessagesByExpiry($expiresAt: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    messagesByExpiry(expiresAt: $expiresAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${encryptedMessageFields} }
      nextToken
    }
  }
`;


// ── MessageReaction ──

const messageReactionFields = `id owner messageId messageGroupId reactorId emoji conversationId expiresAt expiresAtEpoch createdAt updatedAt`;

export const getMessageReaction = /* GraphQL */ `
  query GetMessageReaction($id: ID!) {
    getMessageReaction(id: $id) {
      ${messageReactionFields}
    }
  }
`;

export const listMessageReactions = /* GraphQL */ `
  query ListMessageReactions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listMessageReactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${messageReactionFields} }
      nextToken
    }
  }
`;

export const createMessageReaction = /* GraphQL */ `
  mutation CreateMessageReaction($input: CreateMessageReactionInput!) {
    createMessageReaction(input: $input) {
      ${messageReactionFields}
    }
  }
`;

export const updateMessageReaction = /* GraphQL */ `
  mutation UpdateMessageReaction($input: UpdateMessageReactionInput!) {
    updateMessageReaction(input: $input) {
      ${messageReactionFields}
    }
  }
`;

export const deleteMessageReaction = /* GraphQL */ `
  mutation DeleteMessageReaction($id: ID!) {
    deleteMessageReaction(id: $id) {
      ${messageReactionFields}
    }
  }
`;

export const messageReactionByMessageId = /* GraphQL */ `
  query MessageReactionByMessageId($messageId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    messageReactionByMessageId(messageId: $messageId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageReactionFields} }
      nextToken
    }
  }
`;

export const messageReactionByMessageGroupId = /* GraphQL */ `
  query MessageReactionByMessageGroupId($messageGroupId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    messageReactionByMessageGroupId(messageGroupId: $messageGroupId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageReactionFields} }
      nextToken
    }
  }
`;

export const messageReactionByConversationId = /* GraphQL */ `
  query MessageReactionByConversationId($conversationId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    messageReactionByConversationId(conversationId: $conversationId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageReactionFields} }
      nextToken
    }
  }
`;

export const reactionsByExpiry = /* GraphQL */ `
  query ReactionsByExpiry($expiresAt: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    reactionsByExpiry(expiresAt: $expiresAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageReactionFields} }
      nextToken
    }
  }
`;


// ── UnsolicitedMessageTracker ──

const unsolicitedMessageTrackerFields = `id owner senderId recipientId createdAt updatedAt`;

export const getUnsolicitedMessageTracker = /* GraphQL */ `
  query GetUnsolicitedMessageTracker($id: ID!) {
    getUnsolicitedMessageTracker(id: $id) {
      ${unsolicitedMessageTrackerFields}
    }
  }
`;

export const listUnsolicitedMessageTrackers = /* GraphQL */ `
  query ListUnsolicitedMessageTrackers($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listUnsolicitedMessageTrackers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${unsolicitedMessageTrackerFields} }
      nextToken
    }
  }
`;

export const createUnsolicitedMessageTracker = /* GraphQL */ `
  mutation CreateUnsolicitedMessageTracker($input: CreateUnsolicitedMessageTrackerInput!) {
    createUnsolicitedMessageTracker(input: $input) {
      ${unsolicitedMessageTrackerFields}
    }
  }
`;

export const updateUnsolicitedMessageTracker = /* GraphQL */ `
  mutation UpdateUnsolicitedMessageTracker($input: UpdateUnsolicitedMessageTrackerInput!) {
    updateUnsolicitedMessageTracker(input: $input) {
      ${unsolicitedMessageTrackerFields}
    }
  }
`;

export const deleteUnsolicitedMessageTracker = /* GraphQL */ `
  mutation DeleteUnsolicitedMessageTracker($id: ID!) {
    deleteUnsolicitedMessageTracker(id: $id) {
      ${unsolicitedMessageTrackerFields}
    }
  }
`;

export const unsolicitedMessageTrackerBySenderId = /* GraphQL */ `
  query UnsolicitedMessageTrackerBySenderId($senderId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    unsolicitedMessageTrackerBySenderId(senderId: $senderId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${unsolicitedMessageTrackerFields} }
      nextToken
    }
  }
`;


// ── BlockList ──

const blockListFields = `id owner blockerUserId blockedUserId createdAt updatedAt`;

export const getBlockList = /* GraphQL */ `
  query GetBlockList($id: ID!) {
    getBlockList(id: $id) {
      ${blockListFields}
    }
  }
`;

export const listBlockLists = /* GraphQL */ `
  query ListBlockLists($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listBlockLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${blockListFields} }
      nextToken
    }
  }
`;

export const createBlockList = /* GraphQL */ `
  mutation CreateBlockList($input: CreateBlockListInput!) {
    createBlockList(input: $input) {
      ${blockListFields}
    }
  }
`;

export const updateBlockList = /* GraphQL */ `
  mutation UpdateBlockList($input: UpdateBlockListInput!) {
    updateBlockList(input: $input) {
      ${blockListFields}
    }
  }
`;

export const deleteBlockList = /* GraphQL */ `
  mutation DeleteBlockList($id: ID!) {
    deleteBlockList(id: $id) {
      ${blockListFields}
    }
  }
`;

export const blockListByBlockerUserId = /* GraphQL */ `
  query BlockListByBlockerUserId($blockerUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    blockListByBlockerUserId(blockerUserId: $blockerUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${blockListFields} }
      nextToken
    }
  }
`;

export const blockListByBlockedUserId = /* GraphQL */ `
  query BlockListByBlockedUserId($blockedUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    blockListByBlockedUserId(blockedUserId: $blockedUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${blockListFields} }
      nextToken
    }
  }
`;


// ── MuteList ──

const muteListFields = `id owner muterUserId mutedUserId createdAt updatedAt`;

export const getMuteList = /* GraphQL */ `
  query GetMuteList($id: ID!) {
    getMuteList(id: $id) {
      ${muteListFields}
    }
  }
`;

export const listMuteLists = /* GraphQL */ `
  query ListMuteLists($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listMuteLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${muteListFields} }
      nextToken
    }
  }
`;

export const createMuteList = /* GraphQL */ `
  mutation CreateMuteList($input: CreateMuteListInput!) {
    createMuteList(input: $input) {
      ${muteListFields}
    }
  }
`;

export const updateMuteList = /* GraphQL */ `
  mutation UpdateMuteList($input: UpdateMuteListInput!) {
    updateMuteList(input: $input) {
      ${muteListFields}
    }
  }
`;

export const deleteMuteList = /* GraphQL */ `
  mutation DeleteMuteList($id: ID!) {
    deleteMuteList(id: $id) {
      ${muteListFields}
    }
  }
`;

export const muteListByMuterUserId = /* GraphQL */ `
  query MuteListByMuterUserId($muterUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    muteListByMuterUserId(muterUserId: $muterUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${muteListFields} }
      nextToken
    }
  }
`;

export const muteListByMutedUserId = /* GraphQL */ `
  query MuteListByMutedUserId($mutedUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    muteListByMutedUserId(mutedUserId: $mutedUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${muteListFields} }
      nextToken
    }
  }
`;


// ── ReadReceipt ──

const readReceiptFields = `conversationId userId owner lastReadAt lastReadMessageId lastReadMessageGroupId createdAt updatedAt`;

export const getReadReceipt = /* GraphQL */ `
  query GetReadReceipt($conversationId: String!, $userId: String!) {
    getReadReceipt(conversationId: $conversationId, userId: $userId) {
      ${readReceiptFields}
    }
  }
`;

export const listReadReceipts = /* GraphQL */ `
  query ListReadReceipts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listReadReceipts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${readReceiptFields} }
      nextToken
    }
  }
`;

export const createReadReceipt = /* GraphQL */ `
  mutation CreateReadReceipt($input: CreateReadReceiptInput!) {
    createReadReceipt(input: $input) {
      ${readReceiptFields}
    }
  }
`;

export const updateReadReceipt = /* GraphQL */ `
  mutation UpdateReadReceipt($input: UpdateReadReceiptInput!) {
    updateReadReceipt(input: $input) {
      ${readReceiptFields}
    }
  }
`;

export const deleteReadReceipt = /* GraphQL */ `
  mutation DeleteReadReceipt($conversationId: String!, $userId: String!) {
    deleteReadReceipt(conversationId: $conversationId, userId: $userId) {
      ${readReceiptFields}
    }
  }
`;

export const readReceiptByConversationId = /* GraphQL */ `
  query ReadReceiptByConversationId($conversationId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    readReceiptByConversationId(conversationId: $conversationId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${readReceiptFields} }
      nextToken
    }
  }
`;

export const readReceiptByUserId = /* GraphQL */ `
  query ReadReceiptByUserId($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    readReceiptByUserId(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${readReceiptFields} }
      nextToken
    }
  }
`;


// ── TypingIndicator ──

const typingIndicatorFields = `conversationId userId isTyping lastTypingAt createdAt updatedAt`;

export const getTypingIndicator = /* GraphQL */ `
  query GetTypingIndicator($conversationId: String!, $userId: String!) {
    getTypingIndicator(conversationId: $conversationId, userId: $userId) {
      ${typingIndicatorFields}
    }
  }
`;

export const listTypingIndicators = /* GraphQL */ `
  query ListTypingIndicators($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listTypingIndicators(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${typingIndicatorFields} }
      nextToken
    }
  }
`;

export const createTypingIndicator = /* GraphQL */ `
  mutation CreateTypingIndicator($input: CreateTypingIndicatorInput!) {
    createTypingIndicator(input: $input) {
      ${typingIndicatorFields}
    }
  }
`;

export const updateTypingIndicator = /* GraphQL */ `
  mutation UpdateTypingIndicator($input: UpdateTypingIndicatorInput!) {
    updateTypingIndicator(input: $input) {
      ${typingIndicatorFields}
    }
  }
`;

export const deleteTypingIndicator = /* GraphQL */ `
  mutation DeleteTypingIndicator($conversationId: String!, $userId: String!) {
    deleteTypingIndicator(conversationId: $conversationId, userId: $userId) {
      ${typingIndicatorFields}
    }
  }
`;

export const typingByConversation = /* GraphQL */ `
  query TypingByConversation($conversationId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    typingByConversation(conversationId: $conversationId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${typingIndicatorFields} }
      nextToken
    }
  }
`;


// ── MessageMention ──

const messageMentionFields = `id conversationId messageId messageGroupId mentionedUserId mentionerUserId isRead createdAt updatedAt`;

export const getMessageMention = /* GraphQL */ `
  query GetMessageMention($id: ID!) {
    getMessageMention(id: $id) {
      ${messageMentionFields}
    }
  }
`;

export const listMessageMentions = /* GraphQL */ `
  query ListMessageMentions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listMessageMentions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${messageMentionFields} }
      nextToken
    }
  }
`;

export const createMessageMention = /* GraphQL */ `
  mutation CreateMessageMention($input: CreateMessageMentionInput!) {
    createMessageMention(input: $input) {
      ${messageMentionFields}
    }
  }
`;

export const updateMessageMention = /* GraphQL */ `
  mutation UpdateMessageMention($input: UpdateMessageMentionInput!) {
    updateMessageMention(input: $input) {
      ${messageMentionFields}
    }
  }
`;

export const deleteMessageMention = /* GraphQL */ `
  mutation DeleteMessageMention($id: ID!) {
    deleteMessageMention(id: $id) {
      ${messageMentionFields}
    }
  }
`;

export const mentionsByUser = /* GraphQL */ `
  query MentionsByUser($mentionedUserId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    mentionsByUser(mentionedUserId: $mentionedUserId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageMentionFields} }
      nextToken
    }
  }
`;

export const mentionsByConversation = /* GraphQL */ `
  query MentionsByConversation($conversationId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    mentionsByConversation(conversationId: $conversationId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${messageMentionFields} }
      nextToken
    }
  }
`;


// ── PinnedMessage ──

const pinnedMessageFields = `conversationId messageId messageGroupId pinnedByUserId pinnedAt messagePreview messageSenderId createdAt updatedAt`;

export const getPinnedMessage = /* GraphQL */ `
  query GetPinnedMessage($conversationId: String!, $messageId: String!) {
    getPinnedMessage(conversationId: $conversationId, messageId: $messageId) {
      ${pinnedMessageFields}
    }
  }
`;

export const listPinnedMessages = /* GraphQL */ `
  query ListPinnedMessages($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPinnedMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${pinnedMessageFields} }
      nextToken
    }
  }
`;

export const createPinnedMessage = /* GraphQL */ `
  mutation CreatePinnedMessage($input: CreatePinnedMessageInput!) {
    createPinnedMessage(input: $input) {
      ${pinnedMessageFields}
    }
  }
`;

export const updatePinnedMessage = /* GraphQL */ `
  mutation UpdatePinnedMessage($input: UpdatePinnedMessageInput!) {
    updatePinnedMessage(input: $input) {
      ${pinnedMessageFields}
    }
  }
`;

export const deletePinnedMessage = /* GraphQL */ `
  mutation DeletePinnedMessage($conversationId: String!, $messageId: String!) {
    deletePinnedMessage(conversationId: $conversationId, messageId: $messageId) {
      ${pinnedMessageFields}
    }
  }
`;

export const pinnedByConversation = /* GraphQL */ `
  query PinnedByConversation($conversationId: String!, $pinnedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    pinnedByConversation(conversationId: $conversationId, pinnedAt: $pinnedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${pinnedMessageFields} }
      nextToken
    }
  }
`;


// ── Poll ──

const pollFields = `id owner conversationId creatorUserId question options allowMultiple isAnonymous expiresAt isClosed totalVotes pollCreatedAt audienceType optionVoteCounts resultsExpireAt visibilityStatus createdAt updatedAt`;

export const getPoll = /* GraphQL */ `
  query GetPoll($id: ID!) {
    getPoll(id: $id) {
      ${pollFields}
    }
  }
`;

export const listPolls = /* GraphQL */ `
  query ListPolls($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPolls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${pollFields} }
      nextToken
    }
  }
`;

export const createPoll = /* GraphQL */ `
  mutation CreatePoll($input: CreatePollInput!) {
    createPoll(input: $input) {
      ${pollFields}
    }
  }
`;

export const updatePoll = /* GraphQL */ `
  mutation UpdatePoll($input: UpdatePollInput!) {
    updatePoll(input: $input) {
      ${pollFields}
    }
  }
`;

export const deletePoll = /* GraphQL */ `
  mutation DeletePoll($id: ID!) {
    deletePoll(id: $id) {
      ${pollFields}
    }
  }
`;

export const pollsByConversation = /* GraphQL */ `
  query PollsByConversation($conversationId: String!, $pollCreatedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    pollsByConversation(conversationId: $conversationId, pollCreatedAt: $pollCreatedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${pollFields} }
      nextToken
    }
  }
`;

export const pollsByAudience = /* GraphQL */ `
  query PollsByAudience($audienceType: String!, $pollCreatedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    pollsByAudience(audienceType: $audienceType, pollCreatedAt: $pollCreatedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${pollFields} }
      nextToken
    }
  }
`;

export const pollsByCreator = /* GraphQL */ `
  query PollsByCreator($creatorUserId: String!, $pollCreatedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    pollsByCreator(creatorUserId: $creatorUserId, pollCreatedAt: $pollCreatedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${pollFields} }
      nextToken
    }
  }
`;


// ── Flag ──

const flagFields = `id owner contentType contentId reporterId reasons details status reporterContentKey createdAt updatedAt`;

export const getFlag = /* GraphQL */ `
  query GetFlag($id: ID!) {
    getFlag(id: $id) {
      ${flagFields}
    }
  }
`;

export const listFlags = /* GraphQL */ `
  query ListFlags($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFlags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${flagFields} }
      nextToken
    }
  }
`;

export const createFlag = /* GraphQL */ `
  mutation CreateFlag($input: CreateFlagInput!) {
    createFlag(input: $input) {
      ${flagFields}
    }
  }
`;

export const updateFlag = /* GraphQL */ `
  mutation UpdateFlag($input: UpdateFlagInput!) {
    updateFlag(input: $input) {
      ${flagFields}
    }
  }
`;

export const deleteFlag = /* GraphQL */ `
  mutation DeleteFlag($id: ID!) {
    deleteFlag(id: $id) {
      ${flagFields}
    }
  }
`;

export const flagByContentId = /* GraphQL */ `
  query FlagByContentId($contentId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    flagByContentId(contentId: $contentId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${flagFields} }
      nextToken
    }
  }
`;

export const flagByReporterId = /* GraphQL */ `
  query FlagByReporterId($reporterId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    flagByReporterId(reporterId: $reporterId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${flagFields} }
      nextToken
    }
  }
`;

export const flagByReporterContentKey = /* GraphQL */ `
  query FlagByReporterContentKey($reporterContentKey: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    flagByReporterContentKey(reporterContentKey: $reporterContentKey, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${flagFields} }
      nextToken
    }
  }
`;

export const flagByStatus = /* GraphQL */ `
  query FlagByStatus($status: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    flagByStatus(status: $status, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${flagFields} }
      nextToken
    }
  }
`;


// ── ModerationCase ──

const moderationCaseFields = `id contentType contentId contentOwnerId caseStatus decision decisionReason decidedAt decidedBy severityScore uniqueFlaggers totalFlags assignedTo assignedAt contentSnapshot snapshotAt aiStatus aiCategory aiRiskScore aiRationale aiScoredAt aiModel createdAt updatedAt`;

export const getModerationCase = /* GraphQL */ `
  query GetModerationCase($id: ID!) {
    getModerationCase(id: $id) {
      ${moderationCaseFields}
    }
  }
`;

export const listModerationCases = /* GraphQL */ `
  query ListModerationCases($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listModerationCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${moderationCaseFields} }
      nextToken
    }
  }
`;

export const createModerationCase = /* GraphQL */ `
  mutation CreateModerationCase($input: CreateModerationCaseInput!) {
    createModerationCase(input: $input) {
      ${moderationCaseFields}
    }
  }
`;

export const updateModerationCase = /* GraphQL */ `
  mutation UpdateModerationCase($input: UpdateModerationCaseInput!) {
    updateModerationCase(input: $input) {
      ${moderationCaseFields}
    }
  }
`;

export const deleteModerationCase = /* GraphQL */ `
  mutation DeleteModerationCase($id: ID!) {
    deleteModerationCase(id: $id) {
      ${moderationCaseFields}
    }
  }
`;

export const moderationCaseByContentId = /* GraphQL */ `
  query ModerationCaseByContentId($contentId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    moderationCaseByContentId(contentId: $contentId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${moderationCaseFields} }
      nextToken
    }
  }
`;

export const moderationCaseByCaseStatus = /* GraphQL */ `
  query ModerationCaseByCaseStatus($caseStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    moderationCaseByCaseStatus(caseStatus: $caseStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${moderationCaseFields} }
      nextToken
    }
  }
`;

export const moderationCaseByAssignedTo = /* GraphQL */ `
  query ModerationCaseByAssignedTo($assignedTo: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    moderationCaseByAssignedTo(assignedTo: $assignedTo, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${moderationCaseFields} }
      nextToken
    }
  }
`;

export const moderationCaseByContentOwnerId = /* GraphQL */ `
  query ModerationCaseByContentOwnerId($contentOwnerId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    moderationCaseByContentOwnerId(contentOwnerId: $contentOwnerId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${moderationCaseFields} }
      nextToken
    }
  }
`;


// ── ModerationAction ──

const moderationActionFields = `id caseId actorId actorRole actionType actionPayload createdAt updatedAt`;

export const getModerationAction = /* GraphQL */ `
  query GetModerationAction($id: ID!) {
    getModerationAction(id: $id) {
      ${moderationActionFields}
    }
  }
`;

export const listModerationActions = /* GraphQL */ `
  query ListModerationActions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listModerationActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${moderationActionFields} }
      nextToken
    }
  }
`;

export const createModerationAction = /* GraphQL */ `
  mutation CreateModerationAction($input: CreateModerationActionInput!) {
    createModerationAction(input: $input) {
      ${moderationActionFields}
    }
  }
`;

export const updateModerationAction = /* GraphQL */ `
  mutation UpdateModerationAction($input: UpdateModerationActionInput!) {
    updateModerationAction(input: $input) {
      ${moderationActionFields}
    }
  }
`;

export const deleteModerationAction = /* GraphQL */ `
  mutation DeleteModerationAction($id: ID!) {
    deleteModerationAction(id: $id) {
      ${moderationActionFields}
    }
  }
`;

export const moderationActionByCaseId = /* GraphQL */ `
  query ModerationActionByCaseId($caseId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    moderationActionByCaseId(caseId: $caseId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${moderationActionFields} }
      nextToken
    }
  }
`;

export const moderationActionByActorId = /* GraphQL */ `
  query ModerationActionByActorId($actorId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    moderationActionByActorId(actorId: $actorId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${moderationActionFields} }
      nextToken
    }
  }
`;


// ── Story ──

const storyFields = `id owner creatorUserId segmentIds audienceType excludedUserIds expiresAt totalViewCount totalReactionCount visibilityStatus hiddenReason hiddenAt moderationCaseId isDualCamera createdAt updatedAt`;

export const getStory = /* GraphQL */ `
  query GetStory($id: ID!) {
    getStory(id: $id) {
      ${storyFields}
    }
  }
`;

export const listStories = /* GraphQL */ `
  query ListStories($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storyFields} }
      nextToken
    }
  }
`;

export const createStory = /* GraphQL */ `
  mutation CreateStory($input: CreateStoryInput!) {
    createStory(input: $input) {
      ${storyFields}
    }
  }
`;

export const updateStory = /* GraphQL */ `
  mutation UpdateStory($input: UpdateStoryInput!) {
    updateStory(input: $input) {
      ${storyFields}
    }
  }
`;

export const deleteStory = /* GraphQL */ `
  mutation DeleteStory($id: ID!) {
    deleteStory(id: $id) {
      ${storyFields}
    }
  }
`;

export const listStoriesByCreator = /* GraphQL */ `
  query ListStoriesByCreator($creatorUserId: String!, $expiresAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listStoriesByCreator(creatorUserId: $creatorUserId, expiresAt: $expiresAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyFields} }
      nextToken
    }
  }
`;

export const listStoriesByExpiry = /* GraphQL */ `
  query ListStoriesByExpiry($expiresAt: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listStoriesByExpiry(expiresAt: $expiresAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyFields} }
      nextToken
    }
  }
`;

export const listStoriesByVisibility = /* GraphQL */ `
  query ListStoriesByVisibility($visibilityStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listStoriesByVisibility(visibilityStatus: $visibilityStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyFields} }
      nextToken
    }
  }
`;


// ── StorySegment ──

const storySegmentFields = `id owner storyId creatorUserId mediaType mediaUrl thumbnailUrl mediaDuration mediaWidth mediaHeight textOverlays stickers drawingPaths caption displayOrder displayDuration backgroundColor hasSound soundMuted viewCount reactionCount visibilityStatus hiddenReason flagCount createdAt updatedAt`;

export const getStorySegment = /* GraphQL */ `
  query GetStorySegment($id: ID!) {
    getStorySegment(id: $id) {
      ${storySegmentFields}
    }
  }
`;

export const listStorySegments = /* GraphQL */ `
  query ListStorySegments($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStorySegments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storySegmentFields} }
      nextToken
    }
  }
`;

export const createStorySegment = /* GraphQL */ `
  mutation CreateStorySegment($input: CreateStorySegmentInput!) {
    createStorySegment(input: $input) {
      ${storySegmentFields}
    }
  }
`;

export const updateStorySegment = /* GraphQL */ `
  mutation UpdateStorySegment($input: UpdateStorySegmentInput!) {
    updateStorySegment(input: $input) {
      ${storySegmentFields}
    }
  }
`;

export const deleteStorySegment = /* GraphQL */ `
  mutation DeleteStorySegment($id: ID!) {
    deleteStorySegment(id: $id) {
      ${storySegmentFields}
    }
  }
`;

export const listSegmentsByStory = /* GraphQL */ `
  query ListSegmentsByStory($storyId: String!, $displayOrder: Int, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listSegmentsByStory(storyId: $storyId, displayOrder: $displayOrder, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storySegmentFields} }
      nextToken
    }
  }
`;

export const listSegmentsByCreator = /* GraphQL */ `
  query ListSegmentsByCreator($creatorUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listSegmentsByCreator(creatorUserId: $creatorUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storySegmentFields} }
      nextToken
    }
  }
`;


// ── StoryView ──

const storyViewFields = `id owner storyId segmentId viewerId viewedAt createdAt updatedAt`;

export const getStoryView = /* GraphQL */ `
  query GetStoryView($id: ID!) {
    getStoryView(id: $id) {
      ${storyViewFields}
    }
  }
`;

export const listStoryViews = /* GraphQL */ `
  query ListStoryViews($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStoryViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storyViewFields} }
      nextToken
    }
  }
`;

export const createStoryView = /* GraphQL */ `
  mutation CreateStoryView($input: CreateStoryViewInput!) {
    createStoryView(input: $input) {
      ${storyViewFields}
    }
  }
`;

export const updateStoryView = /* GraphQL */ `
  mutation UpdateStoryView($input: UpdateStoryViewInput!) {
    updateStoryView(input: $input) {
      ${storyViewFields}
    }
  }
`;

export const deleteStoryView = /* GraphQL */ `
  mutation DeleteStoryView($id: ID!) {
    deleteStoryView(id: $id) {
      ${storyViewFields}
    }
  }
`;

export const listViewsByStory = /* GraphQL */ `
  query ListViewsByStory($storyId: String!, $viewedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listViewsByStory(storyId: $storyId, viewedAt: $viewedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyViewFields} }
      nextToken
    }
  }
`;

export const listViewsByViewer = /* GraphQL */ `
  query ListViewsByViewer($viewerId: String!, $viewedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listViewsByViewer(viewerId: $viewerId, viewedAt: $viewedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyViewFields} }
      nextToken
    }
  }
`;

export const listViewsBySegment = /* GraphQL */ `
  query ListViewsBySegment($segmentId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listViewsBySegment(segmentId: $segmentId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyViewFields} }
      nextToken
    }
  }
`;


// ── StoryReaction ──

const storyReactionFields = `id owner storyId segmentId reactorUserId emoji createdAt updatedAt`;

export const getStoryReaction = /* GraphQL */ `
  query GetStoryReaction($id: ID!) {
    getStoryReaction(id: $id) {
      ${storyReactionFields}
    }
  }
`;

export const listStoryReactions = /* GraphQL */ `
  query ListStoryReactions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStoryReactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storyReactionFields} }
      nextToken
    }
  }
`;

export const createStoryReaction = /* GraphQL */ `
  mutation CreateStoryReaction($input: CreateStoryReactionInput!) {
    createStoryReaction(input: $input) {
      ${storyReactionFields}
    }
  }
`;

export const updateStoryReaction = /* GraphQL */ `
  mutation UpdateStoryReaction($input: UpdateStoryReactionInput!) {
    updateStoryReaction(input: $input) {
      ${storyReactionFields}
    }
  }
`;

export const deleteStoryReaction = /* GraphQL */ `
  mutation DeleteStoryReaction($id: ID!) {
    deleteStoryReaction(id: $id) {
      ${storyReactionFields}
    }
  }
`;

export const listReactionsByStory = /* GraphQL */ `
  query ListReactionsByStory($storyId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listReactionsByStory(storyId: $storyId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyReactionFields} }
      nextToken
    }
  }
`;

export const listReactionsBySegment = /* GraphQL */ `
  query ListReactionsBySegment($segmentId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listReactionsBySegment(segmentId: $segmentId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyReactionFields} }
      nextToken
    }
  }
`;

export const listReactionsByUser = /* GraphQL */ `
  query ListReactionsByUser($reactorUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listReactionsByUser(reactorUserId: $reactorUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyReactionFields} }
      nextToken
    }
  }
`;

export const listReactionsByStoryAndUser = /* GraphQL */ `
  query ListReactionsByStoryAndUser($storyId: String!, $reactorUserId: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listReactionsByStoryAndUser(storyId: $storyId, reactorUserId: $reactorUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyReactionFields} }
      nextToken
    }
  }
`;


// ── CloseFriend ──

const closeFriendFields = `id owner userId friendId addedAt createdAt updatedAt`;

export const getCloseFriend = /* GraphQL */ `
  query GetCloseFriend($id: ID!) {
    getCloseFriend(id: $id) {
      ${closeFriendFields}
    }
  }
`;

export const listCloseFriends = /* GraphQL */ `
  query ListCloseFriends($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listCloseFriends(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${closeFriendFields} }
      nextToken
    }
  }
`;

export const createCloseFriend = /* GraphQL */ `
  mutation CreateCloseFriend($input: CreateCloseFriendInput!) {
    createCloseFriend(input: $input) {
      ${closeFriendFields}
    }
  }
`;

export const updateCloseFriend = /* GraphQL */ `
  mutation UpdateCloseFriend($input: UpdateCloseFriendInput!) {
    updateCloseFriend(input: $input) {
      ${closeFriendFields}
    }
  }
`;

export const deleteCloseFriend = /* GraphQL */ `
  mutation DeleteCloseFriend($id: ID!) {
    deleteCloseFriend(id: $id) {
      ${closeFriendFields}
    }
  }
`;

export const closeFriendsByUser = /* GraphQL */ `
  query CloseFriendsByUser($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    closeFriendsByUser(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${closeFriendFields} }
      nextToken
    }
  }
`;

export const closeFriendsByFriend = /* GraphQL */ `
  query CloseFriendsByFriend($friendId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    closeFriendsByFriend(friendId: $friendId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${closeFriendFields} }
      nextToken
    }
  }
`;


// ── StoryMute ──

const storyMuteFields = `id owner userId mutedUserId mutedAt createdAt updatedAt`;

export const getStoryMute = /* GraphQL */ `
  query GetStoryMute($id: ID!) {
    getStoryMute(id: $id) {
      ${storyMuteFields}
    }
  }
`;

export const listStoryMutes = /* GraphQL */ `
  query ListStoryMutes($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStoryMutes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storyMuteFields} }
      nextToken
    }
  }
`;

export const createStoryMute = /* GraphQL */ `
  mutation CreateStoryMute($input: CreateStoryMuteInput!) {
    createStoryMute(input: $input) {
      ${storyMuteFields}
    }
  }
`;

export const updateStoryMute = /* GraphQL */ `
  mutation UpdateStoryMute($input: UpdateStoryMuteInput!) {
    updateStoryMute(input: $input) {
      ${storyMuteFields}
    }
  }
`;

export const deleteStoryMute = /* GraphQL */ `
  mutation DeleteStoryMute($id: ID!) {
    deleteStoryMute(id: $id) {
      ${storyMuteFields}
    }
  }
`;

export const storyMutesByUser = /* GraphQL */ `
  query StoryMutesByUser($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    storyMutesByUser(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyMuteFields} }
      nextToken
    }
  }
`;


// ── StoryTopRowFavorite ──

const storyTopRowFavoriteFields = `id owner userId favoriteUserId position addedAt createdAt updatedAt`;

export const getStoryTopRowFavorite = /* GraphQL */ `
  query GetStoryTopRowFavorite($id: ID!) {
    getStoryTopRowFavorite(id: $id) {
      ${storyTopRowFavoriteFields}
    }
  }
`;

export const listStoryTopRowFavorites = /* GraphQL */ `
  query ListStoryTopRowFavorites($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStoryTopRowFavorites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storyTopRowFavoriteFields} }
      nextToken
    }
  }
`;

export const createStoryTopRowFavorite = /* GraphQL */ `
  mutation CreateStoryTopRowFavorite($input: CreateStoryTopRowFavoriteInput!) {
    createStoryTopRowFavorite(input: $input) {
      ${storyTopRowFavoriteFields}
    }
  }
`;

export const updateStoryTopRowFavorite = /* GraphQL */ `
  mutation UpdateStoryTopRowFavorite($input: UpdateStoryTopRowFavoriteInput!) {
    updateStoryTopRowFavorite(input: $input) {
      ${storyTopRowFavoriteFields}
    }
  }
`;

export const deleteStoryTopRowFavorite = /* GraphQL */ `
  mutation DeleteStoryTopRowFavorite($id: ID!) {
    deleteStoryTopRowFavorite(id: $id) {
      ${storyTopRowFavoriteFields}
    }
  }
`;

export const topRowFavoritesByUser = /* GraphQL */ `
  query TopRowFavoritesByUser($userId: String!, $position: Int, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    topRowFavoritesByUser(userId: $userId, position: $position, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyTopRowFavoriteFields} }
      nextToken
    }
  }
`;

export const topRowFavoritesByFavorite = /* GraphQL */ `
  query TopRowFavoritesByFavorite($favoriteUserId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    topRowFavoritesByFavorite(favoriteUserId: $favoriteUserId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyTopRowFavoriteFields} }
      nextToken
    }
  }
`;


// ── PromptSuggestion ──

const promptSuggestionFields = `id promptText category tags visibility audience experimentGroup isFeatured featuredOrder publishAt expiresAt language usageCount viewCount clickThroughRate automationStatus automationCooldownHours lastAutomatedUseAt automationUseCount reportCount lastReportedAt moderationStatus moderationNotes createdBy lastEditedBy lastEditedAt isDeleted deletedAt deletedBy createdAt updatedAt`;

export const getPromptSuggestion = /* GraphQL */ `
  query GetPromptSuggestion($id: ID!) {
    getPromptSuggestion(id: $id) {
      ${promptSuggestionFields}
    }
  }
`;

export const listPromptSuggestions = /* GraphQL */ `
  query ListPromptSuggestions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPromptSuggestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;

export const createPromptSuggestion = /* GraphQL */ `
  mutation CreatePromptSuggestion($input: CreatePromptSuggestionInput!) {
    createPromptSuggestion(input: $input) {
      ${promptSuggestionFields}
    }
  }
`;

export const updatePromptSuggestion = /* GraphQL */ `
  mutation UpdatePromptSuggestion($input: UpdatePromptSuggestionInput!) {
    updatePromptSuggestion(input: $input) {
      ${promptSuggestionFields}
    }
  }
`;

export const deletePromptSuggestion = /* GraphQL */ `
  mutation DeletePromptSuggestion($id: ID!) {
    deletePromptSuggestion(id: $id) {
      ${promptSuggestionFields}
    }
  }
`;

export const suggestionsByCategory = /* GraphQL */ `
  query SuggestionsByCategory($category: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    suggestionsByCategory(category: $category, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;

export const suggestionsByVisibility = /* GraphQL */ `
  query SuggestionsByVisibility($visibility: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    suggestionsByVisibility(visibility: $visibility, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;

export const suggestionsByLanguage = /* GraphQL */ `
  query SuggestionsByLanguage($language: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    suggestionsByLanguage(language: $language, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;

export const suggestionsByModerationStatus = /* GraphQL */ `
  query SuggestionsByModerationStatus($moderationStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    suggestionsByModerationStatus(moderationStatus: $moderationStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;

export const suggestionsByCreator = /* GraphQL */ `
  query SuggestionsByCreator($createdBy: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    suggestionsByCreator(createdBy: $createdBy, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;

export const automationEligibleSuggestions = /* GraphQL */ `
  query AutomationEligibleSuggestions($automationStatus: String!, $usageCount: Int, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    automationEligibleSuggestions(automationStatus: $automationStatus, usageCount: $usageCount, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${promptSuggestionFields} }
      nextToken
    }
  }
`;


// ── AutomationRule ──

const automationRuleFields = `id name description personaId sourceType scheduleType customCronExpression activeHoursStart activeHoursEnd activeDaysOfWeek timezone maxPostsPerDay cooldownMinutesBetweenPosts eligibleCategories eligibleLanguages minPriorUsageCount maxPriorUsageCount requireModerationClean expiryOptions enabled enabledStatus lastExecutedAt lastPostCreatedAt postsCreatedToday postsCreatedTodayDate createdBy lastEditedBy lastEditedAt isDeleted deletedAt deletedBy createdAt updatedAt`;

export const getAutomationRule = /* GraphQL */ `
  query GetAutomationRule($id: ID!) {
    getAutomationRule(id: $id) {
      ${automationRuleFields}
    }
  }
`;

export const listAutomationRules = /* GraphQL */ `
  query ListAutomationRules($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listAutomationRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${automationRuleFields} }
      nextToken
    }
  }
`;

export const createAutomationRule = /* GraphQL */ `
  mutation CreateAutomationRule($input: CreateAutomationRuleInput!) {
    createAutomationRule(input: $input) {
      ${automationRuleFields}
    }
  }
`;

export const updateAutomationRule = /* GraphQL */ `
  mutation UpdateAutomationRule($input: UpdateAutomationRuleInput!) {
    updateAutomationRule(input: $input) {
      ${automationRuleFields}
    }
  }
`;

export const deleteAutomationRule = /* GraphQL */ `
  mutation DeleteAutomationRule($id: ID!) {
    deleteAutomationRule(id: $id) {
      ${automationRuleFields}
    }
  }
`;

export const automationRuleByPersonaId = /* GraphQL */ `
  query AutomationRuleByPersonaId($personaId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    automationRuleByPersonaId(personaId: $personaId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationRuleFields} }
      nextToken
    }
  }
`;

export const automationRuleByEnabledStatus = /* GraphQL */ `
  query AutomationRuleByEnabledStatus($enabledStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    automationRuleByEnabledStatus(enabledStatus: $enabledStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationRuleFields} }
      nextToken
    }
  }
`;

export const automationRuleBySourceType = /* GraphQL */ `
  query AutomationRuleBySourceType($sourceType: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    automationRuleBySourceType(sourceType: $sourceType, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationRuleFields} }
      nextToken
    }
  }
`;


// ── AutomationExecution ──

const automationExecutionFields = `id ruleId personaId executionStatus executionStartedAt executionCompletedAt skipReason promptId suggestionId selectedExpiryHours errorMessage errorStack contextSnapshot createdAt updatedAt`;

export const getAutomationExecution = /* GraphQL */ `
  query GetAutomationExecution($id: ID!) {
    getAutomationExecution(id: $id) {
      ${automationExecutionFields}
    }
  }
`;

export const listAutomationExecutions = /* GraphQL */ `
  query ListAutomationExecutions($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listAutomationExecutions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${automationExecutionFields} }
      nextToken
    }
  }
`;

export const createAutomationExecution = /* GraphQL */ `
  mutation CreateAutomationExecution($input: CreateAutomationExecutionInput!) {
    createAutomationExecution(input: $input) {
      ${automationExecutionFields}
    }
  }
`;

export const updateAutomationExecution = /* GraphQL */ `
  mutation UpdateAutomationExecution($input: UpdateAutomationExecutionInput!) {
    updateAutomationExecution(input: $input) {
      ${automationExecutionFields}
    }
  }
`;

export const deleteAutomationExecution = /* GraphQL */ `
  mutation DeleteAutomationExecution($id: ID!) {
    deleteAutomationExecution(id: $id) {
      ${automationExecutionFields}
    }
  }
`;

export const executionsByRule = /* GraphQL */ `
  query ExecutionsByRule($ruleId: String!, $executionStartedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    executionsByRule(ruleId: $ruleId, executionStartedAt: $executionStartedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationExecutionFields} }
      nextToken
    }
  }
`;

export const executionsByPersona = /* GraphQL */ `
  query ExecutionsByPersona($personaId: String!, $executionStartedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    executionsByPersona(personaId: $personaId, executionStartedAt: $executionStartedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationExecutionFields} }
      nextToken
    }
  }
`;

export const executionsByStatus = /* GraphQL */ `
  query ExecutionsByStatus($executionStatus: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    executionsByStatus(executionStatus: $executionStatus, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationExecutionFields} }
      nextToken
    }
  }
`;

export const executionsByPrompt = /* GraphQL */ `
  query ExecutionsByPrompt($promptId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    executionsByPrompt(promptId: $promptId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${automationExecutionFields} }
      nextToken
    }
  }
`;


// ── AgeVerification ──

const ageVerificationFields = `userId owner status ageTier dobFromSignup dobFromDocument dobMatch documentType documentExpiration documentCountry facematchScore livenessScore verifiedAt rejectedAt rejectionReason attemptCount maxAttempts lastAttemptAt moderationCaseId documentHashSha256 createdAt updatedAt`;

export const getAgeVerification = /* GraphQL */ `
  query GetAgeVerification($userId: String!) {
    getAgeVerification(userId: $userId) {
      ${ageVerificationFields}
    }
  }
`;

export const listAgeVerifications = /* GraphQL */ `
  query ListAgeVerifications($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listAgeVerifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${ageVerificationFields} }
      nextToken
    }
  }
`;

export const createAgeVerification = /* GraphQL */ `
  mutation CreateAgeVerification($input: CreateAgeVerificationInput!) {
    createAgeVerification(input: $input) {
      ${ageVerificationFields}
    }
  }
`;

export const updateAgeVerification = /* GraphQL */ `
  mutation UpdateAgeVerification($input: UpdateAgeVerificationInput!) {
    updateAgeVerification(input: $input) {
      ${ageVerificationFields}
    }
  }
`;

export const deleteAgeVerification = /* GraphQL */ `
  mutation DeleteAgeVerification($userId: String!) {
    deleteAgeVerification(userId: $userId) {
      ${ageVerificationFields}
    }
  }
`;

export const ageVerificationsByStatus = /* GraphQL */ `
  query AgeVerificationsByStatus($status: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    ageVerificationsByStatus(status: $status, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${ageVerificationFields} }
      nextToken
    }
  }
`;

export const ageVerificationsByDocHash = /* GraphQL */ `
  query AgeVerificationsByDocHash($documentHashSha256: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    ageVerificationsByDocHash(documentHashSha256: $documentHashSha256, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${ageVerificationFields} }
      nextToken
    }
  }
`;


// ── VerificationAttempt ──

const verificationAttemptFields = `id userId owner attemptNumber status failureReason facematchScore livenessScore dobExtracted docTypeExtracted docExpirationExtracted documentHashSha256 startedAt completedAt processingDurationMs createdAt updatedAt`;

export const getVerificationAttempt = /* GraphQL */ `
  query GetVerificationAttempt($id: ID!) {
    getVerificationAttempt(id: $id) {
      ${verificationAttemptFields}
    }
  }
`;

export const listVerificationAttempts = /* GraphQL */ `
  query ListVerificationAttempts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listVerificationAttempts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${verificationAttemptFields} }
      nextToken
    }
  }
`;

export const createVerificationAttempt = /* GraphQL */ `
  mutation CreateVerificationAttempt($input: CreateVerificationAttemptInput!) {
    createVerificationAttempt(input: $input) {
      ${verificationAttemptFields}
    }
  }
`;

export const updateVerificationAttempt = /* GraphQL */ `
  mutation UpdateVerificationAttempt($input: UpdateVerificationAttemptInput!) {
    updateVerificationAttempt(input: $input) {
      ${verificationAttemptFields}
    }
  }
`;

export const deleteVerificationAttempt = /* GraphQL */ `
  mutation DeleteVerificationAttempt($id: ID!) {
    deleteVerificationAttempt(id: $id) {
      ${verificationAttemptFields}
    }
  }
`;

export const attemptsByUser = /* GraphQL */ `
  query AttemptsByUser($userId: String!, $startedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    attemptsByUser(userId: $userId, startedAt: $startedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${verificationAttemptFields} }
      nextToken
    }
  }
`;

export const attemptsByDocHash = /* GraphQL */ `
  query AttemptsByDocHash($documentHashSha256: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    attemptsByDocHash(documentHashSha256: $documentHashSha256, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${verificationAttemptFields} }
      nextToken
    }
  }
`;


// ── Horn ──

const hornFields = `id owner creatorUserId videoUrl thumbnailUrl durationMs aspectRatio caption hasSound isDeleted expiresFromFeedAt expiresFromProfileAt visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId impressionCount viewCount likeCount commentCount skipCount rewatchCount avgWatchRatioX100 completionCount reportCount postedAt createdAt updatedAt`;

export const getHorn = /* GraphQL */ `
  query GetHorn($id: ID!) {
    getHorn(id: $id) {
      ${hornFields}
    }
  }
`;

export const listHorns = /* GraphQL */ `
  query ListHorns($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listHorns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${hornFields} }
      nextToken
    }
  }
`;

export const createHorn = /* GraphQL */ `
  mutation CreateHorn($input: CreateHornInput!) {
    createHorn(input: $input) {
      ${hornFields}
    }
  }
`;

export const updateHorn = /* GraphQL */ `
  mutation UpdateHorn($input: UpdateHornInput!) {
    updateHorn(input: $input) {
      ${hornFields}
    }
  }
`;

export const deleteHorn = /* GraphQL */ `
  mutation DeleteHorn($id: ID!) {
    deleteHorn(id: $id) {
      ${hornFields}
    }
  }
`;

export const listHornsByCreator = /* GraphQL */ `
  query ListHornsByCreator($creatorUserId: String!, $postedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    listHornsByCreator(creatorUserId: $creatorUserId, postedAt: $postedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornFields} }
      nextToken
    }
  }
`;

export const hornsByFeedExpiry = /* GraphQL */ `
  query HornsByFeedExpiry($expiresFromFeedAt: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    hornsByFeedExpiry(expiresFromFeedAt: $expiresFromFeedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornFields} }
      nextToken
    }
  }
`;

export const hornsByProfileExpiry = /* GraphQL */ `
  query HornsByProfileExpiry($expiresFromProfileAt: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    hornsByProfileExpiry(expiresFromProfileAt: $expiresFromProfileAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornFields} }
      nextToken
    }
  }
`;

export const hornsByVisibility = /* GraphQL */ `
  query HornsByVisibility($visibilityStatus: String!, $postedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    hornsByVisibility(visibilityStatus: $visibilityStatus, postedAt: $postedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornFields} }
      nextToken
    }
  }
`;


// ── HornEngagement ──

const hornEngagementFields = `id hornId viewerUserId eventType watchDurationMs eventAt createdAt updatedAt`;

export const getHornEngagement = /* GraphQL */ `
  query GetHornEngagement($id: ID!) {
    getHornEngagement(id: $id) {
      ${hornEngagementFields}
    }
  }
`;

export const listHornEngagements = /* GraphQL */ `
  query ListHornEngagements($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listHornEngagements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${hornEngagementFields} }
      nextToken
    }
  }
`;

export const createHornEngagement = /* GraphQL */ `
  mutation CreateHornEngagement($input: CreateHornEngagementInput!) {
    createHornEngagement(input: $input) {
      ${hornEngagementFields}
    }
  }
`;

export const updateHornEngagement = /* GraphQL */ `
  mutation UpdateHornEngagement($input: UpdateHornEngagementInput!) {
    updateHornEngagement(input: $input) {
      ${hornEngagementFields}
    }
  }
`;

export const deleteHornEngagement = /* GraphQL */ `
  mutation DeleteHornEngagement($id: ID!) {
    deleteHornEngagement(id: $id) {
      ${hornEngagementFields}
    }
  }
`;

export const engagementsByHorn = /* GraphQL */ `
  query EngagementsByHorn($hornId: String!, $eventAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    engagementsByHorn(hornId: $hornId, eventAt: $eventAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornEngagementFields} }
      nextToken
    }
  }
`;

export const engagementsByViewer = /* GraphQL */ `
  query EngagementsByViewer($viewerUserId: String!, $eventAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    engagementsByViewer(viewerUserId: $viewerUserId, eventAt: $eventAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornEngagementFields} }
      nextToken
    }
  }
`;


// ── HornComment ──

const hornCommentFields = `id owner hornId commenterUserId text likeCount visibilityStatus hiddenReason hiddenAt hiddenBy moderationCaseId parentCommentId replyCount commentedAt createdAt updatedAt`;

export const getHornComment = /* GraphQL */ `
  query GetHornComment($id: ID!) {
    getHornComment(id: $id) {
      ${hornCommentFields}
    }
  }
`;

export const listHornComments = /* GraphQL */ `
  query ListHornComments($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listHornComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${hornCommentFields} }
      nextToken
    }
  }
`;

export const createHornComment = /* GraphQL */ `
  mutation CreateHornComment($input: CreateHornCommentInput!) {
    createHornComment(input: $input) {
      ${hornCommentFields}
    }
  }
`;

export const updateHornComment = /* GraphQL */ `
  mutation UpdateHornComment($input: UpdateHornCommentInput!) {
    updateHornComment(input: $input) {
      ${hornCommentFields}
    }
  }
`;

export const deleteHornComment = /* GraphQL */ `
  mutation DeleteHornComment($id: ID!) {
    deleteHornComment(id: $id) {
      ${hornCommentFields}
    }
  }
`;

export const commentsByHorn = /* GraphQL */ `
  query CommentsByHorn($hornId: String!, $commentedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    commentsByHorn(hornId: $hornId, commentedAt: $commentedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornCommentFields} }
      nextToken
    }
  }
`;

export const commentRepliesByHorn = /* GraphQL */ `
  query CommentRepliesByHorn($parentCommentId: String!, $commentedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    commentRepliesByHorn(parentCommentId: $parentCommentId, commentedAt: $commentedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornCommentFields} }
      nextToken
    }
  }
`;


// ── Feedback ──

const feedbackFields = `id owner userEmail userDisplayName messageWhatHappened messageExpected messageSuggestion screenshotKeys status adminResponse respondedAt respondedByAdminId submittedAt createdAt updatedAt`;

export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      ${feedbackFields}
    }
  }
`;

export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${feedbackFields} }
      nextToken
    }
  }
`;

export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback($input: CreateFeedbackInput!) {
    createFeedback(input: $input) {
      ${feedbackFields}
    }
  }
`;

export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback($input: UpdateFeedbackInput!) {
    updateFeedback(input: $input) {
      ${feedbackFields}
    }
  }
`;

export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback($id: ID!) {
    deleteFeedback(id: $id) {
      ${feedbackFields}
    }
  }
`;


// ── TesterSignup ──

const testerSignupFields = `id firstName lastName email phone platform referredByUserId ipAddress signupSource status createdAt updatedAt`;

export const getTesterSignup = /* GraphQL */ `
  query GetTesterSignup($id: ID!) {
    getTesterSignup(id: $id) {
      ${testerSignupFields}
    }
  }
`;

export const listTesterSignups = /* GraphQL */ `
  query ListTesterSignups($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listTesterSignups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${testerSignupFields} }
      nextToken
    }
  }
`;

export const createTesterSignup = /* GraphQL */ `
  mutation CreateTesterSignup($input: CreateTesterSignupInput!) {
    createTesterSignup(input: $input) {
      ${testerSignupFields}
    }
  }
`;

export const updateTesterSignup = /* GraphQL */ `
  mutation UpdateTesterSignup($input: UpdateTesterSignupInput!) {
    updateTesterSignup(input: $input) {
      ${testerSignupFields}
    }
  }
`;

export const deleteTesterSignup = /* GraphQL */ `
  mutation DeleteTesterSignup($id: ID!) {
    deleteTesterSignup(id: $id) {
      ${testerSignupFields}
    }
  }
`;

export const testerSignupByStatus = /* GraphQL */ `
  query TesterSignupByStatus($status: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    testerSignupByStatus(status: $status, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${testerSignupFields} }
      nextToken
    }
  }
`;


export const followByFollowerId = /* GraphQL */ `
  query FollowByFollowerId($followerId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    followByFollowerId(followerId: $followerId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${followFields} }
      nextToken
    }
  }
`;

export const followByFollowingId = /* GraphQL */ `
  query FollowByFollowingId($followingId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    followByFollowingId(followingId: $followingId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${followFields} }
      nextToken
    }
  }
`;


// ============================================
// StoryHighlight
// ============================================

const storyHighlightFields = `id owner userId title coverImageUrl storySegmentIds displayOrder createdAt updatedAt`;

export const getStoryHighlight = /* GraphQL */ `
  query GetStoryHighlight($id: ID!) {
    getStoryHighlight(id: $id) {
      ${storyHighlightFields}
    }
  }
`;

export const listStoryHighlights = /* GraphQL */ `
  query ListStoryHighlights($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listStoryHighlights(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${storyHighlightFields} }
      nextToken
    }
  }
`;

export const createStoryHighlight = /* GraphQL */ `
  mutation CreateStoryHighlight($input: CreateStoryHighlightInput!) {
    createStoryHighlight(input: $input) {
      ${storyHighlightFields}
    }
  }
`;

export const updateStoryHighlight = /* GraphQL */ `
  mutation UpdateStoryHighlight($input: UpdateStoryHighlightInput!) {
    updateStoryHighlight(input: $input) {
      ${storyHighlightFields}
    }
  }
`;

export const deleteStoryHighlight = /* GraphQL */ `
  mutation DeleteStoryHighlight($id: ID!) {
    deleteStoryHighlight(id: $id) {
      ${storyHighlightFields}
    }
  }
`;

export const highlightsByUser = /* GraphQL */ `
  query HighlightsByUser($userId: String!, $displayOrder: Int, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    highlightsByUser(userId: $userId, displayOrder: $displayOrder, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${storyHighlightFields} }
      nextToken
    }
  }
`;

// ============================================
// HornRepost
// ============================================

const hornRepostFields = `
  reposterUserId
  originalHornId
  owner
  quoteText
  repostedAt
  originalCreatorId
  originalCreatorHandle
  originalCreatorDisplayName
  originalCreatorAvatarUrl
  originalThumbnailUrl
  originalCaption
  originalCreatedAt
  expiresFromFeedAt
  createdAt
  updatedAt
`;

export const getHornRepost = /* GraphQL */ `
  query GetHornRepost($reposterUserId: String!, $originalHornId: String!) {
    getHornRepost(reposterUserId: $reposterUserId, originalHornId: $originalHornId) {
      ${hornRepostFields}
    }
  }
`;

export const listHornReposts = /* GraphQL */ `
  query ListHornReposts($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listHornReposts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${hornRepostFields} }
      nextToken
    }
  }
`;

export const createHornRepost = /* GraphQL */ `
  mutation CreateHornRepost($input: CreateHornRepostInput!) {
    createHornRepost(input: $input) {
      ${hornRepostFields}
    }
  }
`;

export const updateHornRepost = /* GraphQL */ `
  mutation UpdateHornRepost($input: UpdateHornRepostInput!) {
    updateHornRepost(input: $input) {
      ${hornRepostFields}
    }
  }
`;

export const deleteHornRepost = /* GraphQL */ `
  mutation DeleteHornRepost($reposterUserId: String!, $originalHornId: String!) {
    deleteHornRepost(reposterUserId: $reposterUserId, originalHornId: $originalHornId) {
      ${hornRepostFields}
    }
  }
`;

export const repostsByReposter = /* GraphQL */ `
  query RepostsByReposter($reposterUserId: String!, $repostedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    repostsByReposter(reposterUserId: $reposterUserId, repostedAt: $repostedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornRepostFields} }
      nextToken
    }
  }
`;

export const repostsOfHorn = /* GraphQL */ `
  query RepostsOfHorn($originalHornId: String!, $repostedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    repostsOfHorn(originalHornId: $originalHornId, repostedAt: $repostedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornRepostFields} }
      nextToken
    }
  }
`;

export const repostsByOriginalCreator = /* GraphQL */ `
  query RepostsByOriginalCreator($originalCreatorId: String!, $repostedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    repostsByOriginalCreator(originalCreatorId: $originalCreatorId, repostedAt: $repostedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornRepostFields} }
      nextToken
    }
  }
`;


// ── PostShare ──
// ============================================

const postShareFields = `
  sharerUserId
  originalPostId
  owner
  quoteText
  audienceType
  sharedAt
  originalCreatorId
  originalCreatorHandle
  originalCreatorDisplayName
  originalCreatorAvatarUrl
  originalTextContent
  originalMediaAttachments
  originalExternalUrl
  originalPublishedAt
  visibilityStatus
  hiddenReason
  hiddenAt
  hiddenBy
  moderationCaseId
  createdAt
  updatedAt
`;

export const getPostShare = /* GraphQL */ `
  query GetPostShare($sharerUserId: String!, $originalPostId: String!) {
    getPostShare(sharerUserId: $sharerUserId, originalPostId: $originalPostId) {
      ${postShareFields}
    }
  }
`;

export const listPostShares = /* GraphQL */ `
  query ListPostShares($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPostShares(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${postShareFields} }
      nextToken
    }
  }
`;

export const createPostShare = /* GraphQL */ `
  mutation CreatePostShare($input: CreatePostShareInput!) {
    createPostShare(input: $input) {
      ${postShareFields}
    }
  }
`;

export const updatePostShare = /* GraphQL */ `
  mutation UpdatePostShare($input: UpdatePostShareInput!) {
    updatePostShare(input: $input) {
      ${postShareFields}
    }
  }
`;

export const deletePostShare = /* GraphQL */ `
  mutation DeletePostShare($sharerUserId: String!, $originalPostId: String!) {
    deletePostShare(sharerUserId: $sharerUserId, originalPostId: $originalPostId) {
      ${postShareFields}
    }
  }
`;

export const sharesBySharer = /* GraphQL */ `
  query SharesBySharer($sharerUserId: String!, $sharedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    sharesBySharer(sharerUserId: $sharerUserId, sharedAt: $sharedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postShareFields} }
      nextToken
    }
  }
`;

export const sharesOfPost = /* GraphQL */ `
  query SharesOfPost($originalPostId: String!, $sharedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    sharesOfPost(originalPostId: $originalPostId, sharedAt: $sharedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postShareFields} }
      nextToken
    }
  }
`;

export const sharesByOriginalCreator = /* GraphQL */ `
  query SharesByOriginalCreator($originalCreatorId: String!, $sharedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    sharesByOriginalCreator(originalCreatorId: $originalCreatorId, sharedAt: $sharedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postShareFields} }
      nextToken
    }
  }
`;


// ── MFABackupCode ──

const mfaBackupCodeFields = `userId codeHash usedAt createdAt updatedAt`;

export const getMFABackupCode = /* GraphQL */ `
  query GetMFABackupCode($userId: String!, $codeHash: String!) {
    getMFABackupCode(userId: $userId, codeHash: $codeHash) {
      ${mfaBackupCodeFields}
    }
  }
`;

export const listMFABackupCodes = /* GraphQL */ `
  query ListMFABackupCodes($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listMFABackupCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${mfaBackupCodeFields} }
      nextToken
    }
  }
`;

export const createMFABackupCode = /* GraphQL */ `
  mutation CreateMFABackupCode($input: CreateMFABackupCodeInput!) {
    createMFABackupCode(input: $input) {
      ${mfaBackupCodeFields}
    }
  }
`;

export const updateMFABackupCode = /* GraphQL */ `
  mutation UpdateMFABackupCode($input: UpdateMFABackupCodeInput!) {
    updateMFABackupCode(input: $input) {
      ${mfaBackupCodeFields}
    }
  }
`;

export const deleteMFABackupCode = /* GraphQL */ `
  mutation DeleteMFABackupCode($userId: String!, $codeHash: String!) {
    deleteMFABackupCode(userId: $userId, codeHash: $codeHash) {
      ${mfaBackupCodeFields}
    }
  }
`;

export const backupCodesByUserId = /* GraphQL */ `
  query BackupCodesByUserId($userId: String!, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    backupCodesByUserId(userId: $userId, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${mfaBackupCodeFields} }
      nextToken
    }
  }
`;


// ── CommentLike ──

const commentLikeFields = `id owner commentId commentType likerUserId userCommentKey createdAt updatedAt`;

export const getCommentLike = /* GraphQL */ `
  query GetCommentLike($id: ID!) {
    getCommentLike(id: $id) {
      ${commentLikeFields}
    }
  }
`;

export const listCommentLikes = /* GraphQL */ `
  query ListCommentLikes($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listCommentLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${commentLikeFields} }
      nextToken
    }
  }
`;

export const createCommentLike = /* GraphQL */ `
  mutation CreateCommentLike($input: CreateCommentLikeInput!) {
    createCommentLike(input: $input) {
      ${commentLikeFields}
    }
  }
`;

export const updateCommentLike = /* GraphQL */ `
  mutation UpdateCommentLike($input: UpdateCommentLikeInput!) {
    updateCommentLike(input: $input) {
      ${commentLikeFields}
    }
  }
`;

export const deleteCommentLike = /* GraphQL */ `
  mutation DeleteCommentLike($id: ID!) {
    deleteCommentLike(id: $id) {
      ${commentLikeFields}
    }
  }
`;

export const likesByComment = /* GraphQL */ `
  query LikesByComment($commentId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    likesByComment(commentId: $commentId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${commentLikeFields} }
      nextToken
    }
  }
`;

export const likesByUser = /* GraphQL */ `
  query LikesByUser($likerUserId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    likesByUser(likerUserId: $likerUserId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${commentLikeFields} }
      nextToken
    }
  }
`;


// ── SavedContent ──

const savedContentFields = `id owner userId contentType contentId userContentKey savedAt createdAt updatedAt`;

export const getSavedContent = /* GraphQL */ `
  query GetSavedContent($id: ID!) {
    getSavedContent(id: $id) {
      ${savedContentFields}
    }
  }
`;

export const listSavedContents = /* GraphQL */ `
  query ListSavedContents($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listSavedContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${savedContentFields} }
      nextToken
    }
  }
`;

export const createSavedContent = /* GraphQL */ `
  mutation CreateSavedContent($input: CreateSavedContentInput!) {
    createSavedContent(input: $input) {
      ${savedContentFields}
    }
  }
`;

export const updateSavedContent = /* GraphQL */ `
  mutation UpdateSavedContent($input: UpdateSavedContentInput!) {
    updateSavedContent(input: $input) {
      ${savedContentFields}
    }
  }
`;

export const deleteSavedContent = /* GraphQL */ `
  mutation DeleteSavedContent($id: ID!) {
    deleteSavedContent(id: $id) {
      ${savedContentFields}
    }
  }
`;

export const savedContentByUser = /* GraphQL */ `
  query SavedContentByUser($userId: String!, $savedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    savedContentByUser(userId: $userId, savedAt: $savedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${savedContentFields} }
      nextToken
    }
  }
`;


// ── PostHashtag ──

const postHashtagFields = `id owner hashtag postId creatorUserId publishedAt createdAt updatedAt`;

export const getPostHashtag = /* GraphQL */ `
  query GetPostHashtag($id: ID!) {
    getPostHashtag(id: $id) {
      ${postHashtagFields}
    }
  }
`;

export const listPostHashtags = /* GraphQL */ `
  query ListPostHashtags($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listPostHashtags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${postHashtagFields} }
      nextToken
    }
  }
`;

export const createPostHashtag = /* GraphQL */ `
  mutation CreatePostHashtag($input: CreatePostHashtagInput!) {
    createPostHashtag(input: $input) {
      ${postHashtagFields}
    }
  }
`;

export const updatePostHashtag = /* GraphQL */ `
  mutation UpdatePostHashtag($input: UpdatePostHashtagInput!) {
    updatePostHashtag(input: $input) {
      ${postHashtagFields}
    }
  }
`;

export const deletePostHashtag = /* GraphQL */ `
  mutation DeletePostHashtag($id: ID!) {
    deletePostHashtag(id: $id) {
      ${postHashtagFields}
    }
  }
`;

export const postsByHashtag = /* GraphQL */ `
  query PostsByHashtag($hashtag: String!, $publishedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    postsByHashtag(hashtag: $hashtag, publishedAt: $publishedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${postHashtagFields} }
      nextToken
    }
  }
`;


// ── HornHashtag ──

const hornHashtagFields = `id owner hashtag hornId creatorUserId publishedAt createdAt updatedAt`;

export const getHornHashtag = /* GraphQL */ `
  query GetHornHashtag($id: ID!) {
    getHornHashtag(id: $id) {
      ${hornHashtagFields}
    }
  }
`;

export const listHornHashtags = /* GraphQL */ `
  query ListHornHashtags($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listHornHashtags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${hornHashtagFields} }
      nextToken
    }
  }
`;

export const createHornHashtag = /* GraphQL */ `
  mutation CreateHornHashtag($input: CreateHornHashtagInput!) {
    createHornHashtag(input: $input) {
      ${hornHashtagFields}
    }
  }
`;

export const updateHornHashtag = /* GraphQL */ `
  mutation UpdateHornHashtag($input: UpdateHornHashtagInput!) {
    updateHornHashtag(input: $input) {
      ${hornHashtagFields}
    }
  }
`;

export const deleteHornHashtag = /* GraphQL */ `
  mutation DeleteHornHashtag($id: ID!) {
    deleteHornHashtag(id: $id) {
      ${hornHashtagFields}
    }
  }
`;

export const hornsByHashtag = /* GraphQL */ `
  query HornsByHashtag($hashtag: String!, $publishedAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    hornsByHashtag(hashtag: $hashtag, publishedAt: $publishedAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${hornHashtagFields} }
      nextToken
    }
  }
`;

// ── FollowRequest ──

const followRequestFields = `id owner requesterId targetId status createdAt updatedAt`;

export const getFollowRequest = /* GraphQL */ `
  query GetFollowRequest($id: ID!) {
    getFollowRequest(id: $id) {
      ${followRequestFields}
    }
  }
`;

export const listFollowRequests = /* GraphQL */ `
  query ListFollowRequests($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listFollowRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${followRequestFields} }
      nextToken
    }
  }
`;

export const createFollowRequest = /* GraphQL */ `
  mutation CreateFollowRequest($input: CreateFollowRequestInput!) {
    createFollowRequest(input: $input) {
      ${followRequestFields}
    }
  }
`;

export const updateFollowRequest = /* GraphQL */ `
  mutation UpdateFollowRequest($input: UpdateFollowRequestInput!) {
    updateFollowRequest(input: $input) {
      ${followRequestFields}
    }
  }
`;

export const deleteFollowRequest = /* GraphQL */ `
  mutation DeleteFollowRequest($id: ID!) {
    deleteFollowRequest(id: $id) {
      ${followRequestFields}
    }
  }
`;

export const requestsByTarget = /* GraphQL */ `
  query RequestsByTarget($targetId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    requestsByTarget(targetId: $targetId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${followRequestFields} }
      nextToken
    }
  }
`;

export const requestsByRequester = /* GraphQL */ `
  query RequestsByRequester($requesterId: String!, $createdAt: String, $filter: AWSJSON, $limit: Int, $nextToken: String, $sortDirection: String) {
    requestsByRequester(requesterId: $requesterId, createdAt: $createdAt, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items { ${followRequestFields} }
      nextToken
    }
  }
`;

// ============================================
// ContentScore
// ============================================

const contentScoreFields = `id contentType contentId score title thumbnailUrl creatorUserId creatorHandle creatorDisplayName creatorAvatarUrl engagementSummary contentMeta hashtagPostCount hashtagHornCount computedAt expiresAtEpoch createdAt updatedAt`;

export const getContentScore = /* GraphQL */ `
  query GetContentScore($id: ID!) {
    getContentScore(id: $id) {
      ${contentScoreFields}
    }
  }
`;

export const listContentScores = /* GraphQL */ `
  query ListContentScores($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listContentScores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${contentScoreFields} }
      nextToken
    }
  }
`;

export const createContentScore = /* GraphQL */ `
  mutation CreateContentScore($input: CreateContentScoreInput!) {
    createContentScore(input: $input) {
      ${contentScoreFields}
    }
  }
`;

export const updateContentScore = /* GraphQL */ `
  mutation UpdateContentScore($input: UpdateContentScoreInput!) {
    updateContentScore(input: $input) {
      ${contentScoreFields}
    }
  }
`;

export const deleteContentScore = /* GraphQL */ `
  mutation DeleteContentScore($id: ID!) {
    deleteContentScore(id: $id) {
      ${contentScoreFields}
    }
  }
`;

export const scoresByContentType = /* GraphQL */ `
  query ScoresByContentType($contentType: String!, $score: Int, $sortDirection: String, $filter: AWSJSON, $limit: Int, $nextToken: String) {
    scoresByContentType(contentType: $contentType, score: $score, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${contentScoreFields} }
      nextToken
    }
  }
`;


// ── SuggestedFollow ──

const suggestedFollowFields = `id targetUserId suggestedUserId score reason reasonDetail suggestedHandle suggestedDisplayName suggestedAvatarUrl suggestedIsBlueCheck suggestedFollowerCount mutualFollowerCount computedAt expiresAtEpoch createdAt updatedAt`;

export const getSuggestedFollow = /* GraphQL */ `
  query GetSuggestedFollow($id: ID!) {
    getSuggestedFollow(id: $id) {
      ${suggestedFollowFields}
    }
  }
`;

export const listSuggestedFollows = /* GraphQL */ `
  query ListSuggestedFollows($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listSuggestedFollows(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${suggestedFollowFields} }
      nextToken
    }
  }
`;

export const createSuggestedFollow = /* GraphQL */ `
  mutation CreateSuggestedFollow($input: CreateSuggestedFollowInput!) {
    createSuggestedFollow(input: $input) {
      ${suggestedFollowFields}
    }
  }
`;

export const updateSuggestedFollow = /* GraphQL */ `
  mutation UpdateSuggestedFollow($input: UpdateSuggestedFollowInput!) {
    updateSuggestedFollow(input: $input) {
      ${suggestedFollowFields}
    }
  }
`;

export const deleteSuggestedFollow = /* GraphQL */ `
  mutation DeleteSuggestedFollow($id: ID!) {
    deleteSuggestedFollow(id: $id) {
      ${suggestedFollowFields}
    }
  }
`;

export const suggestionsByTargetUser = /* GraphQL */ `
  query SuggestionsByTargetUser($targetUserId: String!, $sortDirection: String, $filter: AWSJSON, $limit: Int, $nextToken: String) {
    suggestionsByTargetUser(targetUserId: $targetUserId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${suggestedFollowFields} }
      nextToken
    }
  }
`;

// ============================================
// TemporaryBannerMessage
// ============================================

const temporaryBannerMessageFields = `id message isEnabled createdAt updatedAt`;

export const getTemporaryBannerMessage = /* GraphQL */ `
  query GetTemporaryBannerMessage($id: ID!) {
    getTemporaryBannerMessage(id: $id) {
      ${temporaryBannerMessageFields}
    }
  }
`;

export const listTemporaryBannerMessages = /* GraphQL */ `
  query ListTemporaryBannerMessages($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listTemporaryBannerMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { ${temporaryBannerMessageFields} }
      nextToken
    }
  }
`;

export const createTemporaryBannerMessage = /* GraphQL */ `
  mutation CreateTemporaryBannerMessage($input: CreateTemporaryBannerMessageInput!) {
    createTemporaryBannerMessage(input: $input) {
      ${temporaryBannerMessageFields}
    }
  }
`;

export const updateTemporaryBannerMessage = /* GraphQL */ `
  mutation UpdateTemporaryBannerMessage($input: UpdateTemporaryBannerMessageInput!) {
    updateTemporaryBannerMessage(input: $input) {
      ${temporaryBannerMessageFields}
    }
  }
`;

export const deleteTemporaryBannerMessage = /* GraphQL */ `
  mutation DeleteTemporaryBannerMessage($id: ID!) {
    deleteTemporaryBannerMessage(id: $id) {
      ${temporaryBannerMessageFields}
    }
  }
`;
